<ng-container *ngIf="loader == false">
  <div class="row row-details">
    <div class="column1">
      <div class="card top-blue" title="Client Details">
        <em class="fa fa-user-o"></em>:&nbsp;{{ fname }} {{ lname }} <br />
        <em class="fa fa-envelope-o"></em>:&nbsp; {{ user_details.USER_EMAIL }}
        <br />
        <em class="fa fa-phone"></em>:&nbsp;{{ user_details.USER_MOBILE }}<br />
      </div>
    </div>
    <div class="column">
      <div class="card top-orange" title="Current Queue" *ngIf="booking_details.length != 0">
        <em>Created by</em>:&nbsp;{{ pax_detail[0].FIRST_NAME }}
        {{ pax_detail[0].LAST_NAME }}<br />
        <em>Email ID</em>:&nbsp;<span>{{ pax_detail[0].EMAIL_ID }}</span><br />
        <em>Mobile</em>:&nbsp;<span>{{ pax_detail[0].MOBILE_NO }}</span><br />
        <em>Created on</em>:&nbsp;
        {{ booking_details[0].CREATION_TIME | date: "medium" }} <br />
      </div>
    </div>
    <div class="column3">
      <div class="card top-purple " title="Costing Details" *ngIf="booking_details_info.length != 0">
        <ng-container *ngIf="booking_details_info[0].TOTAL_AMOUNT != 0">
          <em class="text-left">Total Payment Made</em>:
          <ng-container
            *ngIf="swmUsed.promocode_amount == undefined && frenzyOffer.promocode_amount == undefined && flat500Offer.promocode_amount == undefined">
            <em class="fa fa-aed"></em>&nbsp;Rs. {{
            (Total_amount_paid+booking_details[0].SSR_AMOUNT+booking_details[0].TI_PRICE + fcAmout + BUNDLE_FARE_AMOUNT
            - paxDiscount - convFeesDiscount - genericOfferDiscountAmount).toFixed(2)}}<br />
          </ng-container>

          <ng-container *ngIf="swmUsed.promocode_amount !== undefined">
            <em class="fa fa-aed"></em>&nbsp;Rs. {{
            (Total_amount_paid+booking_details[0].SSR_AMOUNT+booking_details[0].TI_PRICE + fcAmout + BUNDLE_FARE_AMOUNT
            - paxDiscount - convFeesDiscount - swmUsed.promocode_discount_amount -
            genericOfferDiscountAmount).toFixed(2)}}<br />
          </ng-container>
          <ng-container *ngIf="swmUsed.promocode_amount == undefined && frenzyOffer.promocode_amount !== undefined">
            <em class="fa fa-aed"></em>&nbsp;Rs. {{
            (Total_amount_paid+booking_details[0].SSR_AMOUNT+booking_details[0].TI_PRICE + fcAmout + BUNDLE_FARE_AMOUNT
            - paxDiscount - convFeesDiscount - frenzyOffer.promocode_amount -
            genericOfferDiscountAmount).toFixed(2)}}<br />
          </ng-container>
          <ng-container
            *ngIf="swmUsed.promocode_amount == undefined && frenzyOffer.promocode_amount == undefined && flat500Offer.promocode_amount !== undefined">
            <em class="fa fa-aed"></em>&nbsp;Rs. {{
            (Total_amount_paid+booking_details[0].SSR_AMOUNT+booking_details[0].TI_PRICE + fcAmout + BUNDLE_FARE_AMOUNT
            - paxDiscount - convFeesDiscount - flat500Offer.promocode_amount -
            genericOfferDiscountAmount).toFixed(2)}}<br />
          </ng-container>

        </ng-container>

        <em class="text-left" style=" color: black;" *ngIf="
            booking_details.length != 0 &&
            booking_details[0].TRANSACTION_STATUS == '7'
          ">Payment Refunded </em><br />
        <em class="text-left" style=" color: black;" *ngIf="
            booking_details.length != 0 && booking_details[0].CRIS_STATUS == '7'
          ">Miles Reversed </em><br />
        <em class="text-left" style=" color: red;" *ngIf="
            booking_details.length != 0 &&
            booking_details[0].TRANSACTION_STATUS == '8'
          ">Payment Refund Failed</em><br />
        <em class="text-left" style=" color: red;" *ngIf="
            booking_details.length != 0 && booking_details[0].CRIS_STATUS == '8'
          ">Miles Reverse Failed</em>
      </div>
      <div class="card top-purple " title="Costing Details" *ngIf="!mainScreen">
        <ng-container>
          <em class="text-left">Total Payment Made</em>:
          <em class="fa fa-aed"></em>&nbsp;Rs.0<br />
          <div style="font-size:12px">
            <em class="text-left">First Bonus Miles</em>:
            <em class="fa fa-aed"></em>&nbsp;0<br />
            <em class="text-left">Earn Miles</em>:
            <em class="fa fa-aed"></em>&nbsp;0<br />
            <em class="text-left">Tier Bonus Miles</em>:
            <em class="fa fa-aed"></em>&nbsp;0<br />
            <em class="text-left">Bonus Miles</em>:
            <em class="fa fa-aed"></em>&nbsp;0<br />
          </div>
        </ng-container>
      </div>

    </div>

  </div>

  <div class="row">
    <div class="column-left">
      <div class="tabVertical">
        <button id="defaultOpen" *ngIf="RAC_EDIT == '1'" (click)="openNav('addPax')">
          <span class="glyphicon glyphicon-user"></span> Add Pax
        </button>
        <button (click)="openNav('addNote')">
          <span class="glyphicon glyphicon-book"></span> Add Notes
        </button>
        <button *ngIf="RAC_ADD == '1'" (click)="openNav('addMessage')">
          <span class="glyphicon glyphicon-envelope"></span> New Messgage
        </button>
        <button *ngIf="RAC_EDIT == '1'" (click)="openNav('addCharge')">
          <em class="fa fa-money"></em> Add Charge
        </button>
        <button *ngIf="RAC_EDIT == '1'" class=" close-book" (click)="closeBooking()">
          <span class="glyphicon glyphicon-off"></span> Close Booking
        </button>
      </div>
    </div>
    <div class="column-right ">
      <div class="container " style="width: 100%" *ngIf="mainScreen">
        <div class="tab">
          <button class="tablinks active" (click)="openCity($event, 'home')">
            Itinerary
          </button>
          <button class="tablinks" (click)="openCity($event, 'menu1')">
            Passengers
          </button>

          <button class="tablinks" (click)="openCity($event, 'menu3')">
            Payment
          </button>
          <button class="tablinks" (click)="openCity($event, 'menu8')">
            Miles
          </button>
          <button class="tablinks" (click)="openCity($event, 'menu4')">
            Documents
          </button>
          <button class="tablinks" (click)="openCity($event, 'menu5')">
            Notes
          </button>
          <button class="tablinks" (click)="openCity($event, 'menu6')">
            History
          </button>
          <button class="tablinks" *ngIf="RAC_ADD == '1'" (click)="openCity($event, 'menu7')">
            Message
          </button>

        </div>
        <div id="errdiv" style="text-align: center;color: red "></div>
        <div class="errwrap">
          <div class="errdiv1" id="errs"></div>
        </div>
        <div id="home" class="tabcontent" style="display: block;border: none">
          <div class="widget widget-nopad stacked " style="height: 229px;">
            <div class="widget-header ">
              <h4 style="margin-left: 191px;color: green;" *ngIf="PnrMsg != ''">
                {{ PnrMsg }}
              </h4>
              <h3 style="margin-top: 12px; ">
                <em class="fa fa-plane hide-xs ">&nbsp;</em> Flight Detail (<span class="hide-xs "><strong></strong>
                </span>
                <strong *ngIf="booking_details.length != 0">
                  {{booking_details[0].ORDER_ID.length == 18 ? '' : 'JPUB'}}{{booking_details[0].ORDER_ID}}
                </strong>)
                <ng-container *ngIf="booking_details_info[0].EARN_MILES == undefind">
                  <ng-container
                    *ngIf="booking_details[0].JP_NUMBER != undefined && booking_details[0].JP_NUMBER != null && booking_details[0].JP_NUMBER != '' && booking_details[0].JP_NUMBER != 0">
                    INTERMILES Number ({{(booking_details[0].JP_NUMBER).slice(2,11)}}) </ng-container>
                </ng-container>
                <ng-container *ngIf="booking_details_info[0].EARN_MILES != undefind">
                  <ng-container
                    *ngIf="booking_details[0].JP_NUMBER != undefined && booking_details[0].JP_NUMBER != null && booking_details[0].JP_NUMBER != '' && booking_details[0].JP_NUMBER != 0">
                    INTERMILES Number ({{booking_details[0].JP_NUMBER}}) </ng-container>
                </ng-container>

                <span *ngIf="IS_EMAIL_SENT == 0 || IS_EMAIL_SENT == 2" style="color: #bf4d4d;">
                  Mail Not Sent
                </span>
              </h3>
            </div>

            <div class="col-lg-12" style="margin: 10px 0px 10px 0px;">
              <h4>
                <div class="col-lg-8" style="margin: 0px;padding: 0px;">

                  <ng-container *ngIf="isTBObooking == false">
                    <div *ngIf="booking_details[0].SUPPLIER_ID != undefined &&
                                booking_details[0].SUPPLIER_ID != null &&
                                booking_details[0].SUPPLIER_ID != '' &&
                                booking_details[0].SUPPLIER_ID != 0;else other_content">

                      <div class="col-lg-6"
                        *ngIf="booking_details[0].SUPPLIER_ID != null && booking_details[0].SUPPLIER_ID != undefind">
                        Supplier ID: {{ booking_details[0].SUPPLIER_ID.split("#")[1] }}
                      </div>

                      <div class="col-lg-6"
                        *ngIf="booking_details[0].TRIP_ID != null && booking_details[0].TRIP_ID != undefind ">
                        Travone ID : {{ booking_details[0].TRIP_ID.split("#")[1] }}
                      </div>

                    </div>
                    <ng-template #other_content>

                      <div class="col-lg-6"
                        *ngIf="booking_details[0].TRIP_ID != null && booking_details[0].TRIP_ID != undefind ">
                        Travone ID: {{ booking_details[0].TRIP_ID.split("#")[1] }}
                      </div>
                    </ng-template>
                    <ng-template #other_content>
                      <div class="col-lg-6"
                        *ngIf="isTravelPortBooking == false && booking_details[0].TRIP_ID.startsWith('EMT')">
                        Supplier ID: {{ booking_details[0].TRIP_ID.split("#")[1] }}
                      </div>
                      <div class="col-lg-6"
                        *ngIf="((isTravelPortBooking == true) || (isTravelPortBooking == false && !booking_details[0].TRIP_ID.startsWith('EMT')))">
                        Travone ID: {{ booking_details[0].TRIP_ID.split("#")[1] }}
                      </div>
                    </ng-template>
                  </ng-container>

                  <ng-container *ngIf="isTBObooking == true">

                    <span *ngIf="
                  booking_details[0].TRIP_ID != undefined &&
                  booking_details[0].TRIP_ID != null &&
                  booking_details[0].TRIP_ID != '' &&
                  booking_details[0].TRIP_ID != 0
                ">
                      Supplier ID: {{ booking_details[0].TRIP_ID}}
                    </span>
                    <span *ngIf="
                  booking_details[0].SUPPLIER_ID != undefined &&
                  booking_details[0].SUPPLIER_ID != null &&
                  booking_details[0].SUPPLIER_ID != '' &&
                  booking_details[0].SUPPLIER_ID != 0 && (booking_details[0].TRIP_ID == undefined ||
                  booking_details[0].TRIP_ID == null ||
                  booking_details[0].TRIP_ID == '' ||
                  booking_details[0].TRIP_ID == 0)
                ">

                      Supplier ID: {{ booking_details[0].SUPPLIER_ID}}
                    </span>
                  </ng-container>
                </div>

                <div class="col-lg-4">
                  <span *ngIf="booking_details[0].AFFILIATE_PARTNER">
                    Affiliate Partner: {{ booking_details[0].AFFILIATE_PARTNER.toUpperCase()}}
                  </span>
                </div>
              </h4>
            </div>
            <div class="widget-content ">
              <div class="scroll-x ">
                <ul class="news-items ">
                  <li class="col-md-12 col-sm-12 col-xs-12 ">
                    <div class="col-md-2 "><strong>Destination : </strong></div>
                    <ng-container *ngFor="let item of segment_details; let i = index">
                      <div class="col-md-2 ">
                        {{ item.ORIGIN }} - {{ item.DESTINATION }}
                      </div>
                    </ng-container>
                    <div class="col-md-2 "><strong>Booking Status : </strong> </div>
                    <div class="col-md-2">
                      {{booking_details[0].STATUS_NAME}}
                    </div>

                    <div class="col-md-2 "><strong>Ancillary Status : </strong></div>
                    <div class="col-md-2 " *ngIf="
                        booking_details.length != 0 
                      ">
                      {{all_confirm_status}}
                    </div>

                  </li>
                  <li class="col-md-12 col-sm-12 col-xs-10 " style="margin-top: 10px;">
                    <div class="col-md-2 "><strong> Passengers : </strong></div>
                    <div class="col-md-2 ">&nbsp;{{ passenegerCount }}</div>
                    <div class="col-md-2 "><strong> Trip Type : </strong></div>
                    <div class="col-md-2 " *ngIf="
                        booking_details.length != 0 &&
                        booking_details[0].TRIP_TYPE != null
                      " style="text-transform: capitalize">
                      {{ booking_details[0].TRIP_TYPE.toUpperCase() }}
                    </div>
                    <div class="col-md-2 "><strong> Travel Type : </strong></div>
                    <div class="col-md-2 " *ngIf="
                        booking_details.length != 0 &&
                        booking_details[0].TRAVEL_TYPE != null
                      " style="text-transform: capitalize">
                      {{ booking_details[0].TRAVEL_TYPE.toUpperCase() }}
                    </div>
                  </li>

                  <li *ngIf="roleID == 84" class="col-md-12 col-sm-12 col-xs-12 " style="margin-top: 11px;">
                    <ng-container>
                      <div class="col-md-2 ">
                        <ng-container *ngIf="updatedPNR == false  && !IsOnlySid">
                          <button class="btn-pnr" data-toggle="modal" (click)="closePnr()" data-target="#PnrUpdate">
                            Update PNR
                          </button>
                        </ng-container>
                        <ng-container *ngIf="IsOnlySid">
                          <button class="btn-pnr" data-toggle="modal" (click)="closePnr()" data-target="#PnrUpdate">
                            Update Supplier ID
                          </button>
                        </ng-container>
                      </div>
                    </ng-container>

                    <div class="col-md-2 " style="color: red;font-size: 15px;" *ngIf="
                        booking_details_info.length != 0 &&
                        BOOKING_STATUS == '1'
                      ">
                      <ng-container *ngIf="updatedPNR == false">
                        <button class="btn-pnr" data-toggle="modal" data-target="#reverseMiles">
                          Failed Booking
                        </button>
                      </ng-container>
                    </div>
                  </li>

                  <li class="col-md-12 col-sm-12 col-xs-12 " style="margin-top: 11px;" *ngIf="
                      roleID != 84 &&
                      booking_details_info[0].EARN_MILES == undefind
                    ">
                    <ng-container *ngIf="( ((booking_ref).startsWith('IBFR') || booking_ref < 50000000000) &&
                        (BOOKING_STATUS == '1' || IsOnlySid) &&
                        CRIS_STATUS == '2' &&
                        TRANSACTION_STATUS == '2') || ( ((booking_ref).startsWith('IBFA') || (booking_ref).startsWith('IBFS') || booking_ref > 50000000000) &&
                        BOOKING_STATUS == '1' &&
                        ACCRUAL_STATUS == '2' &&
                        TRANSACTION_STATUS == '2' ) 
                      ">
                      <div class="col-md-2 ">
                        <ng-container *ngIf="updatedPNR == false  && !IsOnlySid">
                          <button class="btn-pnr" data-toggle="modal" (click)="closePnr()" data-target="#PnrUpdate">
                            Update PNR
                          </button>
                        </ng-container>
                        <ng-container *ngIf="IsOnlySid">
                          <button class="btn-pnr" data-toggle="modal" (click)="closePnr()" data-target="#PnrUpdate">
                            Update Supplier ID
                          </button>
                        </ng-container>
                      </div>
                    </ng-container>

                    <div class="col-md-2 " style="color: red;font-size: 15px;" *ngIf="
                        booking_details_info.length != 0 &&
                        BOOKING_STATUS == '1'
                      ">
                      <ng-container *ngIf="updatedPNR == false">
                        <button class="btn-pnr" data-toggle="modal" data-target="#reverseMiles">
                          Failed Booking
                        </button>
                      </ng-container>
                    </div>
                  </li>
                  <li class="col-md-12 col-sm-12 col-xs-12 " style="margin-top: 11px;">
                    <ng-container *ngIf="!isTBObooking">
                      <div class="col-md-2">
                        <ng-container>
                          <button class="btn-pnr" data-toggle="modal" (click)="updateAncillariesNew()"
                            data-target="#updateAncillaries">
                            Update Ancillaries
                          </button>
                        </ng-container>
                      </div>
                    </ng-container>

                    <div class="col-md-2 " style="color: red;font-size: 15px;" *ngIf="!isTBObooking">
                      <ng-container>
                        <button class="btn-pnr" data-toggle="modal" data-target="#updateAncillaries"
                          (click)="refundAncillariesNew()">
                          Refund Ancillaries
                        </button>
                      </ng-container>
                    </div>

                    <div class="col-md-2 " style="color: red;font-size: 15px;">
                      <ng-container>
                        <button class="btn-pnr" data-toggle="modal" data-target="#sendMail" (click)="sendMail()"
                          [disabled]="RAC_EDIT!=1">
                          Send Mail
                        </button>
                      </ng-container>
                    </div>

                    <div class="col-md-2 " style="color: red;font-size: 15px;">
                      <ng-container>
                        <button class="btn-pnr" data-toggle="modal" data-target="" (click)="sendLoungeMail()"
                          [disabled]="!getLoungeData()" [ngClass]="{'disabled-btn': !getLoungeData()}">
                          Send Lounge Mail
                        </button>
                      </ng-container>
                    </div>

                    <div class="col-md-2 " style="color: red;font-size: 15px;">
                      <ng-container *ngIf="isGrowTreesHidden == false">
                        <button class="btn-pnr" data-toggle="modal" data-target="#growTree" (click)="onGrowTreeClick()">
                          Add-ons
                        </button>
                      </ng-container>
                    </div>

                    <div
                      *ngIf="((showContent==false || this.booking_details_info[0].SUPPLIER_NAME == 'TBO') && ((BOOKING_STATUS=='2'||BOOKING_STATUS == 2) || (BOOKING_STATUS==1 ||BOOKING_STATUS=='1') || (BOOKING_STATUS==7 ||BOOKING_STATUS=='7') || (BOOKING_STATUS== 6 ||BOOKING_STATUS=='6') ))"
                      class="col-md-2 " style="color: red;font-size: 15px;">
                      <ng-container>
                        <button class="btn-pnr" id='cancel' data-toggle="modal" data-target='#cancl'>
                          Cancel
                        </button>
                      </ng-container>
                    </div>

                  </li>

                  <li class="col-md-12 col-sm-12 col-xs-12 " style="margin-top: 11px;" *ngIf="
                      roleID != 84 &&
                      booking_details_info[0].EARN_MILES != undefind
                    ">
                    <ng-container *ngIf="(BOOKING_STATUS == '1' || IsOnlySid ) && TRANSACTION_STATUS == '2'">
                      <div class="col-md-2 ">
                        <ng-container *ngIf="updatedPNR == false && !IsOnlySid">
                          <button class="btn-pnr" data-toggle="modal" (click)="closePnr()" data-target="#PnrUpdate">
                            Update PNR
                          </button>
                        </ng-container>
                        <ng-container *ngIf="IsOnlySid">
                          <button class="btn-pnr" data-toggle="modal" (click)="closePnr()" data-target="#PnrUpdate">
                            Update Supplier ID
                          </button>
                        </ng-container>
                      </div>
                    </ng-container>

                    <div class="col-md-2 " style="color: red;font-size: 15px;" *ngIf="
                        booking_details_info.length != 0 &&
                        BOOKING_STATUS == '1'
                      ">
                      <ng-container *ngIf="updatedPNR == false">
                        <button class="btn-pnr" data-toggle="modal" data-target="#reverseMiles">
                          Failed Booking
                        </button>
                      </ng-container>
                    </div>
                  </li>
                  <div *ngIf="isPnrUpdated == true">
                    <div style="margin: 0 auto; text-align: center;">
                      <img src="../../../../assets/img/Loading_Animation.gif" width="8%" height="8%" alt="Loader" />
                    </div>
                  </div>
                  <li class="col-md-12 col-sm-12 col-xs-12 ">
                    <div class="widget widget-table action-table mb-5 ">
                      <div class="widget-content ">
                        <table aria-describedby="orderFlightDetails" class="table table-striped table-bordered ">
                          <thead>
                            <tr>
                              <th scope="col" style="width: 8%; ">Flight</th>
                              <th scope="col" style="width: 8%; ">Dep</th>
                              <th scope="col" style="width: 14%; ">Dep Date</th>
                              <th scope="col" style="width: 8%; ">Arr</th>
                              <th scope="col" style="width: 14%; ">Arr Date</th>
                              <th scope="col" style="width: 12%; ">Airline PNR</th>
                              <th scope="col" style="width: 9%; ">Fare Product</th>
                              <th scope="col" style="width: 9%; ">RBD Class</th>
                              <th scope="col" style="width: 9%; ">Fare Type</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let item of Leg_details; let i = index">
                              <td>
                                {{ item.AIRLINE_CODE }}-{{ item.FLIGHT_NO }}
                              </td>
                              <td>{{ item.ORIGIN }}</td>
                              <td>
                                {{ item.DEPT_DATE | date: "d MMM, y" }}
                                {{ item.DEPT_TIME }}
                              </td>
                              <td>{{ item.DESTINATION }}</td>
                              <td>
                                {{ item.ARR_DATE | date: "d MMM, y" }}
                                {{ item.ARR_TIME }}
                              </td>
                              <td *ngIf="
                                  segment_details[0].AIRLINE_PNR != null &&
                                  segment_details[0].AIRLINE_PNR != ''
                                ">
                                <ng-container *ngIf="item.SEGMENT_REF_NO == 1">
                                  {{ segment_details[0].AIRLINE_PNR }}
                                </ng-container>
                                <ng-container *ngIf="item.SEGMENT_REF_NO == 2">
                                  {{ segment_details[1].AIRLINE_PNR }}
                                </ng-container>
                              </td>

                              <td *ngIf="
                                  segment_details[0].AIRLINE_PNR == null ||
                                  segment_details[0].AIRLINE_PNR == ''
                                ">
                                NA
                              </td>
                              <td>
                                <span *ngIf="
                                    Leg_details[0].FARE_PRODUCT_CATEGORY_TYPE ==
                                      'E' ||
                                    Leg_details[0].FARE_PRODUCT_CATEGORY_TYPE ==
                                      0
                                  ">Economy</span>
                                <span *ngIf="
                                    Leg_details[0].FARE_PRODUCT_CATEGORY_TYPE ==
                                      'B' ||
                                    Leg_details[0].FARE_PRODUCT_CATEGORY_TYPE ==
                                      2
                                  ">Business</span>
                                {{ item.FARE_PRODUCT_CATEGORY }}
                              </td>
                              <td>{{ item.BOOKING_CLASS }}</td>
                              <td>{{ item.FARE_TYPE }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </li>

                </ul>
              </div>
            </div>
          </div>
        </div>

        <div id="menu1" class="tabcontent">
          <div class="widget-content ">
            <div class="scroll-x ">
              <table aria-describedby="itineraryPaxData" class="table table-striped table-bordered ">
                <thead>
                  <tr>
                    <th scope="col" style="width: 5%; ">#</th>
                    <th scope="col" style="width: 35%; ">Itinerary</th>
                    <th scope="col" style="width: 10%; ">Pax Type</th>
                    <th scope="col">Passenger Name</th>
                    <th scope="col" style="width: 12%; ">Date of Birth</th>
                    <th scope="col" style="width: 8%; " class="td-actions "></th>
                  </tr>
                </thead>
                <tbody>

                  <tr *ngFor="let item of passanger_details_Array; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td *ngIf="i + 1 == 1">
                      AIR- {{ segment_details[0].ORIGIN }}-{{
                      segment_details[0].DESTINATION
                      }}-({{booking_details[0].ORDER_ID.length == 18 ? '' : 'JPUB'}}{{booking_details[0].ORDER_ID}})
                    </td>
                    <td *ngIf="i + 1 != 1"></td>
                    <td>{{ item.Paxtype }}</td>
                    <td>
                      {{ item.title }} {{ item.firstName }} {{ item.lastName }}
                    </td>
                    <td>{{ item.DOB }}</td>

                    <td class="td-actions ">

                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div id="menu2" class="tabcontent">
          <div class="widget-content ">
            <div class="scroll-x ">
              <table aria-describedby="menu2Details" class="table table-striped table-bordered ">
                <thead>
                  <tr>
                    <th scope="col" style="width: 25px; ">#</th>
                    <th scope="col" style="width: 50px; ">Type</th>
                    <th scope="col">Description</th>
                    <th scope="col" style="width: 100px; ">Start Date</th>
                    <th scope="col" style="width: 85px; " class="text-center ">
                      Gross<br /><span class="xs-sub-title ">(total)</span>
                    </th>
                    <th scope="col">Currency</th>
                    <th scope="col">Status</th>
                  </tr>
                </thead>

                <tbody>
                  No History Found
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div id="menu3" class="tabcontent">
          <div class="dvHight400 ">
            <table aria-describedby="bookingOrderData" style="width:50% " class="table paymentBorder "
              *ngIf="booking_details_info.length != 0">
              <thead>
                <tr>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="booking_details_info[0].EARN_MILES == undefind">
                  <tr *ngIf="booking_details_info[0].EARN_MILES == undefind">
                    <td style="width:50% "><strong>Miles Redeemed</strong></td>
                    <td> {{booking_details_info[0].MILES_REQUIRED}} INTERMILES</td>
                  </tr>
                  <tr *ngIf="booking_details_info[0].EARN_MILES == undefind">
                    <td style="width:50% "><strong>Miles Balance</strong></td>
                    <td> {{booking_details_info[0].MEMBER_POINT_BALANCE}} INTERMILES</td>
                  </tr>
                  <tr *ngIf="booking_details_info[0].MORE_TO_BUY_JPMILES != 0">
                    <td style="width:50% "><strong>Miles Bought</strong></td>
                    <td>{{booking_details_info[0].MORE_TO_BUY_JPMILES}} INTERMILES</td>
                  </tr>
                  <tr *ngIf="booking_details_info[0].EARN_MILES != undefind">
                    <td style="width:50% "><strong>Miles Redeemed</strong></td>
                    <td> {{booking_details_info[0].MILES_REQUIRED}} INTERMILES</td>
                  </tr>
                  <tr *ngIf="
                      booking_details_info[0].BONUS_MILES != undefind &&
                      booking_details_info[0].BONUS_MILES != '0'
                    ">
                    <td style="width:50% "><strong>Miles Balance</strong></td>
                    <td> {{booking_details_info[0].MEMBER_POINT_BALANCE}} INTERMILES</td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
            <table aria-describedby="IMMilesData" style="width: 100%; margin-left: 10px;">
              <thead>
                <tr>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tr>
                <td style="width: auto"><strong>Fee per/seg/pax</strong></td>
                <td style="width: auto"><strong>No of Segments</strong></td>
                <td style="width: auto"><strong>No of Passengers</strong></td>
                <td style="width: auto">
                  <strong>Convenience Fee({{ Convience_fee_per }})</strong>
                </td>
                <td style="width: auto">
                  <strong>Gst ({{ gst }}%)</strong>
                </td>
                <td style="width: auto"><strong>Total Convenience Fee</strong></td>
              </tr>
              <tr>
                <td>Rs. {{ Convience_fee_per }}</td>
                <td>{{ booking_details[0].NO_OF_SEGMENT }}</td>
                <td>{{ booking_details[0].NO_OF_PASSENGER }}</td>
                <td>Rs.{{ Convience_without_gst }}</td>
                <td>Rs.{{ gst_on_convience.toFixed(2) }}</td>
                <td>Rs.{{ convenineceFees }}</td>
              </tr>
            </table>

            <table aria-describedby="orderConvFeeData" style="width:50% " class="table paymentBorder "
              *ngIf="booking_details_info.length != 0">
              <thead>
                <tr>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="booking_details_info[0].FEES != 0">
                  <td style="width:50% "><strong>Total Convenience Fee</strong></td>
                  <td>Rs. {{ convenineceFees }}</td>
                </tr>
                <tr *ngIf="convFeesDiscount != 0">
                  <td style="width:50% "><strong>ConvFee Discount</strong></td>
                  <td>Rs. {{ convFeesDiscount }}</td>
                </tr>
                <tr *ngIf="booking_details_info[0].MORE_TO_BUY_JPMILES != 0">
                  <td style="width:50% "><strong>Cost of additional INTERMILES</strong></td>
                  <td>Rs. {{(AMOUNT_FOR_EXTRA_MILES).toFixed(2)}}</td>
                </tr>

                <tr *ngIf="booking_details_info[0].MORE_TO_BUY_JPMILES != 0">
                  <td style="width:50% "><strong>Gst on additional INTERMILES ({{gst}}%)</strong></td>
                  <td>Rs. {{(GST_ON_ADDITIONAL_MILES).toFixed(2)}}</td>
                </tr>
                <ng-container *ngIf="booking_details_info[0].EARN_MILES != undefind">
                  <tr *ngIf="booking_details_info[0].TOTAL_BASE_FARE != 0">
                    <td style="width:50% "><strong>Total Base Fare</strong></td>
                    <td>Rs. {{ booking_details[0].TOTAL_BASE_FARE - paxDiscount }}</td>
                  </tr>
                  <tr
                    *ngIf="swmUsed.promocode_discount_amount !== null && swmUsed.promocode_discount_amount !== undefined">
                    <td style="width:50% "><strong>SWM Discount Amount</strong></td>
                    <td>Rs. {{ swmUsed.promocode_discount_amount }}</td>
                  </tr>
                  <tr *ngIf="booking_details_info[0].TOTAL_FEE_N_TAXES != 0">
                    <td style="width:50% "><strong>Total Fees and Taxes</strong></td>
                    <td>Rs. {{ booking_details[0].TOTAL_FEE_N_TAXES }}</td>
                  </tr>

                  <tr *ngIf="booking_details_info[0].TOTAL_FLIGHT_FARE != 0">
                    <td style="width:50% "><strong>Total Flight Fare</strong></td>
                    <td>Rs. {{ booking_details[0].TOTAL_FLIGHT_FARE - paxDiscount}}</td>
                  </tr>
                </ng-container>
                <tr style="width:50% " *ngIf="booking_details_info[0].TOTAL_AMOUNT != 0">
                  <td><strong>Total SSR Amount Paid</strong></td>
                  <td>Rs. {{ (booking_details[0].SSR_AMOUNT+booking_details[0].TI_PRICE + growTreeAmount).toFixed(2)}}</td>
                </tr>
                <tr style="width:50% " *ngIf="BUNDLE_FARE_AMOUNT != 0">
                  <td><strong>SmartSaver (Inclusive of GST)</strong></td>
                  <td>Rs. {{ BUNDLE_FARE_AMOUNT }}</td>
                </tr>
                <tr style="width:50% " *ngIf="showFC">
                  <td><strong>Free Cancellation (Inclusive of GST)</strong></td>
                  <td>Rs. {{ fcAmout }}</td>
                </tr>

                <tr style="width:50%" *ngIf="showFCDiscount">
                  <td><strong>Free Cancellation Base Price</strong></td>
                  <td>Rs. {{ basePriceFCDiscount }}</td>
                </tr>

                <tr style="width:50%" *ngIf="showFCDiscount">
                  <td><strong>Free Cancellation Discount</strong></td>
                  <td>Rs. {{ fCDiscountPrice }}</td>
                </tr>

                <tr *ngIf="frenzyOffer.promocode_amount !== null && frenzyOffer.promocode_amount !== undefined">
                  <td style="width:50% "><strong>Miles Frenzy Discount Amount</strong></td>
                  <td>Rs. {{ frenzyOffer.promocode_amount }}</td>
                </tr>
                <tr *ngIf="flat500Offer.promocode_amount !== null && flat500Offer.promocode_amount !== undefined">
                  <td style="width:50% "><strong>FLAT 500 Discount</strong></td>
                  <td>Rs. {{ flat500Offer.promocode_amount }}</td>
                </tr>

                <tr *ngIf="genericOfferDiscountAmount">
                  <td style="width:50% "><strong>{{genericOfferDiscountTitle}}</strong></td>
                  <td>Rs. {{ genericOfferDiscountAmount }}</td>
                </tr>

                <tr style="width:50% " *ngIf="booking_details_info[0].TOTAL_AMOUNT != 0">
                  <td><strong>Total Amount Paid</strong></td>
                  <td
                    *ngIf="booking_details_info[0].TOTAL_AMOUNT != 0 && swmUsed.promocode_amount == undefined && frenzyOffer.promocode_amount == undefined && flat500Offer.promocode_amount == undefined">
                    Rs. {{ (Total_amount_paid+booking_details[0].SSR_AMOUNT+booking_details[0].TI_PRICE + growTreeAmount + fcAmout +
                    BUNDLE_FARE_AMOUNT - paxDiscount - convFeesDiscount - genericOfferDiscountAmount).toFixed(2)}}</td>
                  <td
                    *ngIf="booking_details_info[0].TOTAL_AMOUNT != 0 && swmUsed.promocode_amount !== undefined && frenzyOffer.promocode_amount == undefined">
                    Rs. {{ (Total_amount_paid+booking_details[0].SSR_AMOUNT+booking_details[0].TI_PRICE + growTreeAmount + fcAmout +
                    BUNDLE_FARE_AMOUNT - paxDiscount - convFeesDiscount -
                    swmUsed.promocode_discount_amount - genericOfferDiscountAmount).toFixed(2)}}</td>
                  <td
                    *ngIf="booking_details_info[0].TOTAL_AMOUNT != 0 && swmUsed.promocode_amount == undefined && frenzyOffer.promocode_amount !== undefined">
                    Rs. {{ (Total_amount_paid+booking_details[0].SSR_AMOUNT+booking_details[0].TI_PRICE + growTreeAmount + fcAmout +
                    BUNDLE_FARE_AMOUNT - paxDiscount - convFeesDiscount - frenzyOffer.promocode_amount -
                    genericOfferDiscountAmount).toFixed(2)}}
                  </td>
                  <td
                    *ngIf="booking_details_info[0].TOTAL_AMOUNT != 0 && swmUsed.promocode_amount == undefined && frenzyOffer.promocode_amount == undefined && flat500Offer.promocode_amount !== undefined">
                    Rs. {{ (Total_amount_paid+booking_details[0].SSR_AMOUNT+booking_details[0].TI_PRICE +  growTreeAmount + fcAmout +
                    BUNDLE_FARE_AMOUNT - paxDiscount - convFeesDiscount - genericOfferDiscountAmount -
                    genericOfferDiscountAmount).toFixed(2)}}
                  </td>
                </tr>
                <tr
                  *ngIf="swmUsed.promocode_discount_amount !== null && swmUsed.promocode_discount_amount !== undefined">
                  <td style="width:50% "><strong>SWM Miles Redeemed</strong></td>
                  <td>{{ swmUsed.promocode_amount }} IM</td>
                </tr>
                <tr style="width:50% " *ngIf="discount_amount > 0">
                  <td><strong>Discount Amount</strong></td>
                  <td>Rs. {{ (discount_amount).toFixed(2) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div id="menu4" class="tabcontent">
          <div class="widget-content ">
            <div class="scroll-x ">
              <div *ngIf="isPnrUpdated == true">
                <div style="margin: 0 auto; text-align: center;">
                  <img src="../../../../assets/img/Loading_Animation.gif" width="8%" height="8%" alt="Loader" />
                </div>
              </div>
              <table aria-describedby="orderDocumentTypeData" class="table table-striped table-bordered ">
                <thead>
                  <tr>
                    <th scope="col" style="width: 5%; ">#</th>
                    <th scope="col" style="width: 15%; ">Doc Type</th>
                    <th scope="col" style="width: 15%; ">Doc No</th>
                    <th scope="col" style="width: 15%; ">Date</th>
                    <th scope="col">Remarks</th>
                    <th scope="col" class="td-actions " style="width: 23%; ">
                      <div *ngIf="ErrMsg != ''" class="pdferr">
                        {{ ErrMsg }}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Invoice</td>
                    <td *ngIf="booking_details_info.length != 0">
                      {{booking_details_info[0].ORDER_ID.length == 18 ? '' :
                      'JPUB'}}{{booking_details_info[0].ORDER_ID}}
                    </td>
                    <td *ngIf="booking_details.length != 0">
                      {{ booking_details[0].CREATION_TIME | date: "d MMM, y" }}
                    </td>
                    <td>fresh invoice</td>
                    <td class="td-actions " *ngIf="BOOKING_STATUS == 2">

                      <a (click)="sendNewInvoiceMail()" class="btn btn-xs btn-primary "><em class="fa fa-envelope-o ">
                        </em></a>
                    </td>
                  </tr>
                  <tr *ngIf="booking_details[0].IS_OFFLINE_BOOKING_PROCESSED == 1">
                    <td>2</td>
                    <td>Retry PNR</td>
                    <td *ngIf="booking_details_info.length != 0">
                      {{booking_details_info[0].ORDER_ID.length == 18 ? '' :
                      'JPUB'}}{{booking_details_info[0].ORDER_ID}}
                    </td>
                    <td *ngIf="booking_details.length != 0">
                      {{ booking_details[0].CREATION_TIME | date: "d MMM, y" }}
                    </td>
                    <td>Retry Revised Fare Update</td>
                    <td class="td-actions ">

                      <a (click)="callUpdatePNRService()" class="btn btn-xs btn-primary "><em
                          class="glyphicon glyphicon-open">
                        </em></a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div id="menu5" class="tabcontent">
          <div class="widget stacked widget-table action-table " *ngIf="Note_details_Array.length == 0">
            <table aria-describedby="orderNotesData" class="table table-striped table-bordered ">
              <thead>
                <tr>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <strong>There aren't any notes for this booking.</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="widget-content" *ngIf="Note_details_Array.length != 0">
            <div class="scroll-x">
              <table aria-describedby="orderNotesDetailsData" class="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th scope="col" style="width: 5%;">#</th>
                    <th scope="col" style="width: 30%;">Note</th>
                    <th scope="col" style="width: 15%;">Note By</th>
                    <th scope="col" style="width: 10%;">Date</th>
                    <th scope="col" style="width: 7%;">Time</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of Note_details_Array; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ item.noteText }}</td>
                    <td>{{ fname }} {{ lname }}</td>
                    <td>{{ item.createdDate | date: "d MMM, y" }}</td>
                    <td>{{ item.createdDate | date: "hh:mm" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div id="menu6" class="tabcontent">
          <div class="widget-content ">
            <div class="scroll-x ">
              <table aria-describedby="orderHistoryData" *ngIf="!historyLoader" class="table table-striped"
                [mfData]="serachtabledata" [mfRowsOnPage]="6">
                <thead>
                  <tr>
                    <th scope="col" style="width: 5%; ">#</th>
                    <th scope="col" style="width: 10%; ">Date</th>
                    <th scope="col" style="width: 6%; ">Time</th>
                    <th scope="col">Description</th>
                    <th scope="col" style="width: 15%; ">Created By</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngIf="historyList.length == 0">
                    <tr>
                      <td colspan="5" class="text-center">
                        <h1>Result Not Found</h1>
                      </td>
                    </tr>
                  </ng-container>
                  <tr class="link"
                    *ngFor="let item of (historyList | paginate: { itemsPerPage: 10, currentPage: p ,totalItems:totalItems });let i = index">
                    <td>{{ sr_number - i }}</td>
                    <td>{{item.CREATED_DATE | date: 'd MMM y' }}</td>
                    <td>{{item.CREATED_DATE | date: 'HH:mm' }}</td>
                    <td>{{item.ACTIVITY_DESCRIPTION}}</td>
                    <td>{{item.USER_NAME}}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="5">
                      <pagination-controls (pageChange)="pageCount($event)" total-items="totalItems">
                      </pagination-controls>
                    </td>
                  </tr>
                </tfoot>
              </table>
              <div *ngIf="historyLoader">
                <div style="margin: 0 auto; text-align: center;">
                  <img src="../../../../assets/img/Loading_Animation.gif" width="8%" height="8%" alt="Loader">

                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="menu7" class="tabcontent">
          <div class="widget stacked widget-table action-table ">
            <table aria-describedby="orderMessageData" class="table table-striped table-bordered ">
              <thead>
                <tr>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <strong>There aren't any messages for this booking.</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div id="menu8" class="tabcontent">
          <div class="dvHight400 ">

            <table aria-describedby="orderMilesData" style="width:50% " class="table paymentBorder "
              *ngIf="booking_details_info.length != 0">
              <thead>
                <tr>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="showContent">
                  <td style="width:50% "><strong>Earn Miles</strong></td>
                  <td>{{ EARN_MILES }} IM</td>
                </tr>
                <tr>
                  <td style="width:50% "><strong>Lounge</strong></td>
                  <td>{{ LOUNGE_MILES }} IM</td>
                </tr>
                <tr>
                  <td style="width:50% "><strong>Seat</strong></td>
                  <td>{{ SEAT_MILES }} IM</td>
                </tr>
                <tr>
                  <td style="width:50% "><strong>Meal</strong></td>
                  <td>{{ MEAL_MILES }} IM</td>
                </tr>
                <tr>
                  <td style="width:50% "><strong>Baggage</strong></td>
                  <td>{{ BAGGAGE_MILES }} IM</td>
                </tr>
                <tr>
                  <td style="width:50% "><strong>Travel Insurance</strong></td>
                  <td>{{ TI_MILES }} IM</td>
                </tr>
                <tr *ngIf="showContent">
                  <td style="width:50% "><strong>Tier Bonus Miles</strong></td>
                  <td>{{ TIER_BONUS_MILES }} IM</td>
                </tr>
                <tr>
                  <td style="width:50% "><strong>Ancillaries Tier Bonus Miles</strong></td>
                  <td>{{ ANCILARIES_TIER_BONUS_MILES }} IM</td>
                </tr>
                <tr *ngIf="showContent">
                  <td style="width:50% "><strong>First Bonus Miles</strong></td>
                  <td>{{ FIRST_BONUS_MILES }} IM</td>
                </tr>
                <tr *ngIf="showContent">
                  <td style="width:50% "><strong>Bonus Miles</strong></td>
                  <td>{{BONUS_MILES}} IM</td>
                </tr>
                <tr *ngIf="showContent">
                  <td style="width:50% "><strong>SmartSaver Bonus</strong></td>
                  <td>{{ BUNDLE_FARE_MILES }} IM</td>
                </tr>
                <tr *ngIf="showContent">
                  <td style="width:50% "><strong>Grow Trees</strong></td>
                  <td>{{ growTreeMiles }} IM</td>
                </tr>


              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="container" style="width: 100%" *ngIf="!mainScreen">
        <div class="widget stacked widget-table action-table ">
          <div class="row " style="margin-bottom: inherit">
            <div style="margin-bottom: 20px;">
              <h3>{{booking_ref}} Booking details</h3>
            </div>
          </div>
          <div class="row " style="margin-bottom: inherit">
            <div class="col-md-3">
              <label class="">Member Category</label>
              <select class="form-control m-input" [(ngModel)]="member_category">
                <option value="B2C" selected>B2C</option>
                <option value="SME">SME</option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="">Flight Type</label>
              <select class="form-control m-input" [(ngModel)]="TBO_Type" (change)='disEvent($event)'>
                <option value="ONEWAY" selected>ONEWAY</option>
                <option value="RETURN">RETURN</option>
              </select>
            </div>
          </div>
          <div class="row " style="margin-bottom: inherit">
            <div class="col-md-3">
              <label class="">First Name</label>
              <input type="text" class="form-control m-input" placeholder="Enter First Name"
                [(ngModel)]=passanger_details.firstName readonly />
              <span id="fnErr" style="color: red;font-size: 10px"></span>
            </div>
            <div class="col-md-3">
              <label class="">Last Name</label>
              <input type="text" [(ngModel)]="passanger_details.lastName" class="form-control m-input"
                placeholder="Enter Last Name" readonly />
              <span id="lnErr" style="color: red;font-size: 10px"></span>
            </div>
          </div>
          <hr style="border-top:2px solid #676a6c1f" *ngIf="TBO_Type =='RETURN'">
          <div class="row" style="margin-bottom: inherit">
            <div class="col-md-3">
              <label class="">Onward PNR</label>
              <input type="text " class="form-control m-input" [(ngModel)]="TBO_Onward_PNR"
                (input)="Type($event,'onwardpnr')" placeholder="Enter Onward PNR" style="text-transform: uppercase"
                (blur)=dataMethod(0) />
              <span id="onErr" style="color: red;font-size: 10px"></span>
            </div>
            <div class="col-md-3">
              <label class="">Onward Booking ID</label>
              <input type="text " class="form-control m-input" [(ngModel)]="Onward_Booking_ID"
                (input)="Type($event,'onwardid')" placeholder="Enter onward Booking ID"
                style="text-transform: uppercase" (keypress)="keypresshandler($event)" (blur)=dataMethod(1) />
              <span id="obnErr" style="color: red;font-size: 10px"></span>
            </div>
            <div class="col-md-2">
              <label class="">Fare Type</label>
              <select class="form-control m-input" [(ngModel)]="Onward_fare_type" [disabled]="member_category== 'B2C'">
                <option value="B2C" selected>B2C</option>
                <option value="SME">SME</option>
              </select>
            </div>
            <div class="col-md-4">
              <label class="">Onward Remarks</label>
              <input type="text " class="form-control m-input" [(ngModel)]="Onward_Remarks"
                placeholder="Enter onward Remarks" />
            </div>
          </div>
          <div class="row" *ngIf="Onward_fare_type=='SME' && member_category=='SME' && onward_benefits.length > 0">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <h4 class="">Benefits :-</h4>
                </div>
              </div>
              <div class="row" style="margin-bottom: inherit">
                <ng-container *ngFor="let onward_benefit of onward_benefits;let i=index">
                  <div class="col-md-3" *ngIf="onward_benefit.type == 'text-area'">
                    <label class="">{{onward_benefit.name}}</label>
                    <textarea class="form-control m-input" placeholder="{{onward_benefit.name}}" rows="4"
                      style="height: auto !important;" [(ngModel)]="onward_benefits[i].value"
                      maxlength="250"></textarea>
                  </div>
                  <div class="col-md-3" *ngIf="onward_benefit.type == 'dropdown'">
                    <label class="">{{onward_benefit.name}}</label>
                    <select class="form-control m-input" [(ngModel)]="onward_benefits[i].value">
                      <option *ngFor="let drop_list of onward_benefit.default_values;let j = index"
                        value="{{drop_list}}">{{drop_list}}</option>
                    </select>
                  </div>
                </ng-container>
              </div>

            </div>
          </div>

          <hr style="border-top:2px solid #676a6c1f" *ngIf="TBO_Type =='RETURN'">
          <div class="row" style="margin-bottom: inherit">
            <div class="col-md-3" *ngIf="TBO_Type =='RETURN'">
              <label class="">Return PNR</label>
              <input type="text" class="form-control m-input" [(ngModel)]="TBO_Return_PNR"
                (input)="Type($event,'returnpnr')" placeholder="Enter Return PNR" style="text-transform: uppercase"
                (blur)=dataMethod(2) />
              <span id="rnErr" style="color: red;font-size: 10px"></span>
            </div>

            <div class="col-md-3" *ngIf="TBO_Type =='RETURN'">
              <label class="">Return Booking ID</label>
              <input type="text" class="form-control m-input" [(ngModel)]="Return_Booking_ID"
                (input)="Type($event,'returnid')" placeholder="Enter onward Booking ID"
                style="text-transform: uppercase" (blur)=dataMethod(3) (keypress)="keypresshandler($event)" />
              <span id="rbnErr" style="color: red;font-size: 10px"></span>
            </div>
            <div class="col-md-2" *ngIf="TBO_Type =='RETURN'">
              <label class="">Fare Type</label>
              <select class="form-control m-input" [(ngModel)]="Return_fare_type" [disabled]="member_category== 'B2C'">
                <option value="B2C" selected>B2C</option>
                <option value="SME">SME</option>
              </select>
            </div>
            <div class="col-md-4" *ngIf="TBO_Type =='RETURN'">
              <label class="">Return Remarks</label>
              <input type="text" class="form-control m-input" [(ngModel)]="Return_Remarks"
                placeholder="Enter return Remarks" />
            </div>
          </div>
          <div class="row"
            *ngIf="TBO_Type =='RETURN' && Return_fare_type=='SME' && member_category=='SME' && return_benefits.length > 0">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <h4 class="">Benefits :-</h4>
                </div>
              </div>
              <div class="row" style="margin-bottom: inherit">
                <ng-container *ngFor="let return_benefit of return_benefits;let k = index">
                  <div class="col-md-3" *ngIf="return_benefit.type == 'text-area'">
                    <label class="">{{return_benefit.name}}</label>
                    <textarea class="form-control m-input" placeholder="{{return_benefit.name}}" rows="4"
                      style="height: auto !important;" [(ngModel)]="return_benefits[k].value"
                      maxlength="250"></textarea>
                  </div>
                  <div class="col-md-3" *ngIf="return_benefit.type == 'dropdown'">
                    <label class="">{{return_benefit.name}}</label>
                    <select class="form-control m-input" [(ngModel)]="return_benefits[k].value">
                      <option *ngFor="let return_drop_list of return_benefit.default_values;let j = index"
                        value="{{return_drop_list}}">{{return_drop_list}}</option>
                    </select>
                  </div>
                </ng-container>
              </div>

            </div>
          </div>
          <div class="row">
            <div class="col-md-12" style="display: flex;
              align-content: center;
              text-align: center;
              justify-content: center;">
              <div class="btn clear-button button-margin">

                <button class="btn btn-primary  commonbutt" type="button" (click)=TBO_Booking()
                  [disabled]="buttonFlag == true">
                  Search
                </button>
                <span style="color: red;">
                  <h3>{{TBO_sms}} </h3>
                </span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div id="myNav" class="overlay">
    <div class="modal-header">
      <span class="head-text">
        <span class="glyphicon glyphicon-user icon-head"></span>
        Modal Header
      </span>
      <span style="float: right;">
        <button (click)="closeNav('myNav')">
          close
        </button>
      </span>
    </div>
    <div class="overlay-content">
      jhfjhfhjfkgh
    </div>
  </div>

  <div id="addPaxhead" class="overBack">
    <div id="addPax" class="overlay">
      <div class="modal-header">
        <span class="head-text">
          <span class="glyphicon glyphicon-user icon-head"></span>
          Manage Passenger Info
        </span>
        <span style="float: right;">
          <button (click)="closeNav('addPax')">
            close
          </button>
        </span>
      </div>
      <div class="overlay-content">
        <div class="m-portlet">
          <div style="padding: 2% 4% 2% 2%">
            <div>
              <div>
                <div class="col-md-3">
                  General Information
                </div>
                <div class="clr"></div>
                <div class="divider addDiv"></div>

                <div class="col-md-3">
                  <label>Pax Type </label>
                </div>
                <input type="hidden" [(ngModel)]="passanger_details.id" class="form-control m-input" />
                <div class="col-md-3">
                  <select class="form-control m-input" [(ngModel)]="passanger_details.Paxtype" (click)="SelectPaxType()"
                    id="selectPax">
                    <option disabled value="Select">Select</option>
                    <option value="ADT">Adult</option>
                    <option value="CHD">Child</option>
                    <option value="INF">Infant</option>
                  </select>
                  <span id="JpErr"></span>
                </div>
                <div class="clr"></div>
                <div class="addDiv"></div>

                <div class="col-md-3">
                  <label>Title</label>

                </div>
                <div class="col-md-3">
                  <select class="form-control m-input" [(ngModel)]="passanger_details.title">
                    <option disabled value="Select Title">Title</option>
                    <ng-container *ngIf="Paxtype == 'ADT'; else others">
                      <option value="Mr">Mr</option>
                      <option value="Ms">Ms</option>
                      <option value="Mrs">Mrs</option>
                    </ng-container>
                    <ng-template #others>
                      <option value="Miss">Miss</option>
                      <option value="Mstr">Mstr</option>
                    </ng-template>
                  </select>
                  <span id="JpErr"></span>
                </div>
                <div class="clr"></div>
                <div class="addDiv"></div>

                <div class="col-md-3">
                  <label class="">First Name</label>
                </div>
                <div class="col-md-3">
                  <input type="text" [(ngModel)]="passanger_details.firstName" class="form-control m-input"
                    placeholder="Enter First Name" />
                  <span id="fnErr"></span>
                </div>
                <div class="clr"></div>
                <div class="addDiv"></div>

                <div class="col-md-3">
                  <label class="">Last Name</label>
                </div>
                <div class="col-md-3">
                  <input type="text" [(ngModel)]="passanger_details.lastName" class="form-control m-input"
                    placeholder="Enter Last Name" />
                  <span id="lnErr"></span>
                </div>
                <div class="clr"></div>
                <div class="addDiv"></div>

                <div class="col-md-3">
                  <label class="">Email</label>
                </div>
                <div class="col-md-3">
                  <input type="text" class="form-control m-input" [(ngModel)]="passanger_details.email"
                    placeholder="Enter Email" />
                  <span id="lnErr"></span>
                </div>
                <div class="clr"></div>
                <div class="addDiv"></div>

                <div class="col-md-3">
                  <label class="">Mobile</label>
                </div>
                <div class="col-md-3">
                  <input type="text" class="form-control m-input" [(ngModel)]="passanger_details.mobile"
                    placeholder="Enter Mobile" />
                  <span id="lnErr"></span>
                </div>
                <div class="clr"></div>
                <div class="addDiv"></div>

                <div class="col-md-3">
                  <label class="">Date of Birth</label>
                </div>
                <div class="col-md-3">
                  <input type="date" class="form-control m-input" [(ngModel)]="passanger_details.DOB"
                    placeholder="Enter Mobile" />
                  <span id="lnErr"></span>
                </div>

                <div class="clr"></div>
                <div class="addDiv"></div>

                <div class="col-md-3">
                  <label class="">Passport No</label>
                </div>
                <div class="col-md-3">
                  <input type="text" class="form-control m-input" [(ngModel)]="passanger_details.PASSPORT_NO"
                    placeholder="Enter Passport No" />
                  <span id="lnErr"></span>
                </div>

                <div class="clr"></div>
                <div class="addDiv"></div>

                <div class="col-md-3">
                  <label class="">Gender</label>
                </div>
                <div class="col-md-3" style="padding-right: 145px;">

                  <input type="radio" name="gender" [(ngModel)]="passanger_details.gender" value="male" />
                  Male
                  <input type="radio" name="gender" [(ngModel)]="passanger_details.gender" value="female" />
                  Female<br />
                  <span id="lnErr"></span>
                </div>

                <div class="clr"></div>
                <div class="addDiv"></div>

                <div class="col-md-3">
                  <button class="submit-btn" (click)="AddPaxData('addPax')">
                    Submit
                  </button>
                </div>

                <div class="clr"></div>
                <div class="divider addDiv"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="addNotehead" class="overBack">
    <div id="addNote" class="overlay">
      <div class="modal-header">
        <span class="head-text">
          <span class="glyphicon glyphicon-user icon-head"></span>
          Manage Booking Note
        </span>
        <span style="float: right;">
          <button (click)="closeNav('addNote')">
            close
          </button>
        </span>
      </div>
      <div class="overlay-content">
        <div class="m-portlet">
          <div style="padding: 2% 4% 2% 2%">
            <div>
              <div>
                <div class="col-md-3">
                  Booking Note Details
                </div>
                <div class="col-md-3" id="NoteErr"></div>

                <input type="hidden" [(ngModel)]="Note_details.id" class="form-control m-input" />
                <div class="clr"></div>
                <div class="divider addDiv"></div>

                <div class="col-md-3">
                  <label class="">Note Text</label>
                </div>
                <div class="col-md-3">
                  <textarea cols="10" rows="5" class="form-control m-input" (input)="isNoteEmpty()"
                    [(ngModel)]="Note_details.noteText" placeholder="Enter Text">
                  </textarea>
                  <span id="lnErr"></span>
                </div>
                <div class="clr"></div>
                <div class="divider addDiv"></div>
                <div class="col-md-3">
                  <button class="submit-btn">
                    Submit
                  </button>
                </div>
                <div class="clr"></div>
                <div class="divider addDiv"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="addMessagehead" class="overBack">
    <div id="addMessage" class="overlay">
      <div class="modal-header">
        <span class="head-text">
          <span class="glyphicon glyphicon-user icon-head"></span>
          Manage Message
        </span>
        <span style="float: right;">
          <button (click)="closeNav('addMessage')">
            close
          </button>
        </span>
      </div>
      <div class="overlay-content">
        <div class="m-portlet">
          <div style="padding: 2% 4% 2% 2%">
            <div>
              <div>
                <div class="col-md-3">
                  Message Details
                </div>

                <div class="clr"></div>
                <div class="divider addDiv"></div>

                <div class="col-md-3">
                  <label class="">Message Against </label>
                </div>
                <div class="col-md-3" *ngIf="segment_details.length != 0">
                  <select class="form-control m-input">
                    <option disabled value="Select">Select</option>
                    <option value="1">Adult</option>
                    <option value="2">{{ segment_details[0].ORIGIN }}-{{
                      segment_details[0].DESTINATION
                      }}
                      , TJ</option>
                  </select>
                  <span id="fnErr"></span>
                </div>
                <div class="clr"></div>
                <div class="divider addDiv"></div>

                <div class="col-md-3">
                  <label class="">Message</label>
                </div>
                <div class="col-md-3">
                  <textarea cols="15" rows="5" class="form-control m-input" placeholder="Enter Message">
                  </textarea>
                  <span id="lnErr"></span>
                </div>
                <div class="clr"></div>
                <div class="divider addDiv"></div>

                <div class="col-md-3">
                  <button class="submit-btn">Submit</button>
                </div>

                <div class="clr"></div>
                <div class="divider addDiv"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="addChargehead" class="overBack">
    <div id="addCharge" class="overlay">
      <div class="modal-header">
        <span class="head-text">
          <span class="glyphicon glyphicon-user icon-head"></span>
          Manage Charge / Tax / Discount
        </span>
        <span style="float: right;">
          <button (click)="closeNav('addCharge')">
            close
          </button>
        </span>
      </div>
      <div class="overlay-content">
        <div class="m-portlet">
          <div style="padding: 2% 4% 2% 2%">
            <div>
              <div>
                <div class="col-md-3">
                  Charge Details
                </div>

                <div class="clr"></div>
                <div class="addDiv"></div>

                <div class="col-md-3">
                  <label class="">Charge Type </label>
                </div>
                <div class="col-md-3" *ngIf="segment_details.length != 0">
                  <span style="padding: 14px;">Charge/Tax
                    <input type="radio" [(ngModel)]="Charge_Details.chargeType" name="chargeType" value="CHG" /></span>

                  <span style="padding: 14px;">Discount
                    <input type="radio" [(ngModel)]="Charge_Details.chargeType" name="chargeType" value="DST" /></span>

                  <span id="fnErr"></span>
                </div>
                <div class="clr"></div>
                <div class="addDiv"></div>

                <div class="col-md-8 col-sm-10 col-xs-12" style="margin-left: 285px;">
                  <div class="widget stacked widget-table action-table">
                    <div class="widget-content">
                      <div class="scroll-x">
                        <table aria-describedby="orderChargeData" class="table table-striped table-bordered">
                          <thead>
                            <tr>
                              <th scope="col" style="width: 45%;">Charge Description</th>
                              <th scope="col">
                                Net Amount<span class="xs-sub-title">(AED)</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>

                                <input name="ctl00$cphPageContent$txtDesc" type="text" maxlength="100"
                                  id="ctl00_cphPageContent_txtDesc" [(ngModel)]="Charge_Details.chargeDesc"
                                  autocomplete="off" />
                              </td>
                              <td>
                                <input name="ctl00$cphPageContent$txtNet" type="text" maxlength="10"
                                  [(ngModel)]="Charge_Details.amount" id="ctl00_cphPageContent_txtNet"
                                  autocomplete="off" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="clr"></div>
                <div class="addDiv"></div>

                <div class="col-md-3">
                  <label class="">Apply Charge on</label>
                </div>
                <div class="col-md-3">
                  <span style="padding: 14px;">On Booking
                    <input type="radio" [(ngModel)]="Charge_Details.chargeApply" name="charge" value="1" /></span>

                  <span style="padding: 14px;" *ngIf="segment_details.length != 0">{{ segment_details[0].ORIGIN }}-{{
                    segment_details[0].DESTINATION
                    }}<input type="radio" [(ngModel)]="Charge_Details.chargeApply" name="charge" value="2" /></span>

                  <span id="lnErr"></span>
                </div>
                <div class="clr"></div>
                <div class="addDiv"></div>

                <div class="col-md-3">
                  <label>Currency </label>
                </div>
                <div class="col-md-3">
                  <select class="form-control m-input" [(ngModel)]="Charge_Details.currency">
                    <option value="Select" disabled value="Select">Select</option>
                    <option value="INR">INR</option>
                    <option value="AES">AES</option>
                  </select>
                  <span id="JpErr"></span>
                </div>
                <div class="clr"></div>
                <div class="addDiv"></div>

                <div class="col-md-3">
                  <label class="">Remarks</label>
                </div>
                <div class="col-md-3" style="margin-left: 22px;">
                  <textarea cols="35" rows="5" class="form-control m-input" [(ngModel)]="Charge_Details.Remarks"
                    placeholder="Enter Remarks">
                  </textarea>
                  <span id="lnErr"></span>
                </div>
                <div class="clr"></div>
                <div class="addDiv"></div>
                <div class="col-md-3">
                  <button class="submit-btn" (click)="AddChargeData('addCharge')">
                    Submit
                  </button>
                </div>

                <div class="clr"></div>
                <div class="divider addDiv"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="flightDetailshead" class="overBack">
    <div id="flightDetails" class="overlay">
      <div class="modal-header">
        <span class="head-text">
          <span class="glyphicon glyphicon-user icon-head"></span>
          Manage Flight Details
        </span>
        <span style="float: right;">
          <button (click)="closeNav('flightDetails')">
            close
          </button>
        </span>
      </div>
      <div class="overlay-content">
        <div class="mnd">
          <div class="col-lg-4">
            <label>Client Name</label>
            <span style="margin-left: 26px"> {{ fname }} {{ lname }} </span>
          </div>

          <br />
          <div class="clr"></div>
          <div class="divider"></div>

          <div class="col-lg-3">
            <label>Departure Airport</label>

            <input maxlength="3" type="text" class="form-control m-input" [(ngModel)]="DepartureAirport" />
          </div>

          <div class="col-lg-3">
            <label>Arrival Airport</label>

            <input maxlength="3" type="text" class="form-control m-input" [(ngModel)]="ArivalAirport" />
          </div>
          <div class="col-lg-3">
            <label>PNR Number</label>

            <input maxlength="3" type="text" class="form-control m-input" [(ngModel)]="pnrNumber" />
          </div>
          <div class="col-md-3">
            <label class="">Cabin Class</label>
            <select class="form-control m-input" [(ngModel)]="CABIN_CLASS">
              <option value="" disabled>Select</option>
              <option value="Economy Basic">Economy Basic</option>
              <option value="Economy Standard">Economy Standard</option>
              <option value="Economy Prime">Economy Prime</option>
              <option value="Bussiness">Bussiness</option>
            </select>
          </div>
          <br />
          <div class="clr"></div>
          <div class="divider"></div>
          <div class="col-md-3">
            <label class="">GDS</label>
            <select class="form-control m-input">
              <option value="" disabled>Select</option>
              <option value="Amadeus">Amadeus</option>
              <option value="Gallileo">Gallileo</option>
              <option value="Sabre">Sabre</option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="">Ticketing Supplier </label>
            <select class="form-control m-input" [(ngModel)]="SUPPLIER_NAME">
              <option value="" disabled>Select</option>
              <option value="EaseMyTrip">EaseMyTrip</option>
            </select>
          </div>

          <div class="col-md-3">
            <label class="">Trip Type</label>
            <select class="form-control m-input" [(ngModel)]="tripType">
              <option value="" disabled>Select</option>
              <option value="ONEWAY">Oneway</option>
              <option value="round">Round Trip</option>
            </select>
          </div>

          <div class="col-md-3">
            <label class=""> Fare Type</label>
            <select class="form-control m-input" [(ngModel)]="CABIN_CLASS">
              <option value="" disabled>Select</option>
              <option value="Economy Basic">Economy Basic</option>
              <option value="Economy Standard">Economy Standard</option>
              <option value="Economy Prime">Economy Prime</option>
              <option value="Bussiness">Bussiness</option>
            </select>
          </div>

          <div class="clr"></div>
          <div class="divider"></div>
          <div class="col-md-4">
            <label class=""> Journey Type</label>
            <span style="margin-left: 26px">
              <input type="radio" name="travelType" value="domestic" [(ngModel)]="TRAVEL_TYPE" />
              Domestic
              <input type="radio" name="travelType" value="international" [(ngModel)]="TRAVEL_TYPE" />
              International
            </span>
          </div>
          <br />
          <div class="clr"></div>
          <div class="divider"></div>
          <div>
            <table aria-describedby="orderFlightDetails" class="table table-bordered">
              <tr style="background-color: #e6e1ea;">
                <th scope="col" style="width: 6%">Flight</th>
                <th scope="col" style="width: 7%">D. Airport</th>
                <th scope="col" style="width: 9%">Dep Date</th>
                <th scope="col" style="width: 7%">Dep Time</th>
                <th scope="col" style="width: 6%">Dep Ter</th>
                <th scope="col" style="width: 7%">A. Airport</th>
                <th scope="col" style="width: 9%">Arr Date</th>
                <th scope="col" style="width: 7%">Arr Time</th>
                <th scope="col" style="width: 6%">Arr Ter</th>
                <th scope="col" style="width: 7%">Bkg Class</th>
                <th scope="col" style="width: 9%">AirLine PNR</th>
                <th scope="col" style="width: 5%">Status</th>
                <th scope="col" style="width: 7%">Cbn Class</th>
                <th scope="col" style="width: 8%">Operated By</th>
                <th scope="col"><em class="fa fa-trash-o"></em></th>
              </tr>
              <tr class="addSeg" *ngFor="let item of Leg_details; let i = index">
                <td>
                  <input type="text" value="{{ item.AIRLINE_CODE }}-{{ item.FLIGHT_NO }}" />
                </td>
                <td><input type="text" value="{{ item.ORIGIN }}" /></td>
                <td>
                  <input type="text" value="{{ item.DEPT_DATE | date: 'd MMM, y' }}" />
                </td>
                <td><input type="text" value="{{ item.DEPT_TIME }}" /></td>
                <td><input type="text" value="3" /></td>
                <td><input type="text" value="{{ item.DESTINATION }}" /></td>
                <td>
                  <input type="text" value="{{ item.ARR_DATE | date: 'd MMM, y' }}" />
                </td>
                <td><input type="text" value="{{ item.ARR_TIME }}" /></td>
                <td><input type="text" value="2" /></td>
                <td><input type="text" value="W" /></td>
                <td>
                  <input type="text" value="{{ segment_details[0].AIRLINE_PNR }}" />
                </td>
                <td><input type="text" value="UC" /></td>
                <td><input type="text" /></td>
                <td><input type="text" /></td>
                <td><input type="text" /></td>
              </tr>

              <tr class="addSeg" *ngFor="let item of Leg_detailsArray; let i = index">
                <td>
                  <span><input type="text" maxlength="2" style="width: 40% !important;text-transform: uppercase"
                      [(ngModel)]="Legs_Details.OPERATING_CARRIER" /></span>

                  <span><input type="text" maxlength="4" (keypress)="keypresshandler($event)"
                      style="width: 60% !important" [(ngModel)]="Legs_Details.FLIGHT_NO" />
                  </span>
                </td>
                <td>
                  <input type="text" maxlength="3" style="text-transform: uppercase"
                    [(ngModel)]="Legs_Details.ORIGIN" />
                </td>
                <td>
                  <input type="text" [(ngModel)]="Legs_Details.DEPT_DATE" />
                </td>

                <td>
                  <span><input type="text" maxlength="2" (keypress)="keypresshandler($event)"
                      style="width: 50% !important;" [(ngModel)]="Legs_Details.DEPT_TIME1" /></span>

                  :<span><input type="text" maxlength="2" (keypress)="keypresshandler($event)"
                      style="width: 50% !important;" [(ngModel)]="Legs_Details.DEPT_TIME2" /></span>
                </td>
                <td>
                  <input type="text" [(ngModel)]="Legs_Details.DEPT_TERMINAL" />
                </td>
                <td>
                  <input type="text" maxlength="3" style="text-transform: uppercase"
                    [(ngModel)]="Legs_Details.DESTINATION" />
                </td>
                <td>
                  <input type="text" [(ngModel)]="Legs_Details.ARR_DATE" />
                </td>

                <td>
                  <span><input type="text" maxlength="2" (keypress)="keypresshandler($event)"
                      style="width: 50% !important;" [(ngModel)]="Legs_Details.ARR_TIME1" /></span>

                  :<span><input type="text" maxlength="2" (keypress)="keypresshandler($event)"
                      style="width: 50% !important;" [(ngModel)]="Legs_Details.ARR_TIME2" /></span>
                </td>
                <td>
                  <input type="text" [(ngModel)]="Legs_Details.ARR_TERMINAL" />
                </td>
                <td>
                  <input type="text" [(ngModel)]="Legs_Details.BOOKING_CLASS" />
                </td>
                <td>
                  <input type="text" style="text-transform: uppercase" [(ngModel)]="Legs_Details.AIRLINE_PNR" />
                </td>
                <td><input type="text" [(ngModel)]="Legs_Details.STATUS" /></td>
                <td>
                  <input type="text" [(ngModel)]="Legs_Details.CABIN_CLASS" />
                </td>
                <td>
                  <input type="text" [(ngModel)]="Legs_Details.OPERATED_BY" />
                </td>
              </tr>
            </table>
          </div>
          <br />

          <div class="col-md-12">
            <div class="col-md-2" style="width: 9%!important">
              <span><strong>Pax Details</strong> </span>
            </div>
            <div class="col-md-10">
              <div class="col-md-2" style="width: 13%;">
                <label class="">Adult</label>
                <select class="form-control m-input" [(ngModel)]="AdultCount">
                  <option value="" disabled>Select</option>
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                </select>
              </div>

              <div class="col-md-2" style="width: 13%;">
                <label class="">Child</label>
                <select class="form-control m-input" [(ngModel)]="ChildCount">
                  <option value="" disabled>Select</option>
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                </select>
              </div>

              <div class="col-md-2" style="width: 13%;">
                <label class="">Infant</label>
                <select class="form-control m-input" [(ngModel)]="InfantCount">
                  <option value="" disabled>Select</option>
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                </select>
              </div>
            </div>
          </div>
          <br />
          <div class="clr"></div>
          <div class="divider"></div>
          <div>
            <table aria-describedby="orderPassengerData" class="table table-bordered" style="width: 50%;">
              <tr style="background-color: #e6e1ea;">
                <th scope="col">Type</th>
                <th scope="col">Title</th>
                <th scope="col">First Name</th>
                <th scope="col">Last Name</th>
                <th scope="col">DOB(DD MM YYYY)</th>
              </tr>
              <tr *ngFor="let item of passanger_details_Array; let i = index">
                <td>{{ item.Paxtype }}</td>
                <td>{{ item.title }}</td>
                <td>{{ item.firstName }}</td>
                <td>{{ item.lastName }}</td>
                <td>{{ item.DOB }}</td>
              </tr>
            </table>
          </div>
          <div class="clr"></div>
          <div class="divider"></div>
          <div class="mywrap">
            <div class="mywrap1">
              <span>Fare Details *All Amounts are Per Person basis</span>

              <div>

                <div class="clr"></div>
                <div class="divider"></div>
                <table aria-describedby="orderTaxData" class="table table-bordered">
                  <tr style="background-color: #e6e1ea;">
                    <th scope="col"><em class="fa fa-user"></em></th>
                    <th scope="col">Base Fare(AED)</th>
                    <th scope="col">Tax(AED)</th>
                    <th scope="col">Gross(AED)</th>
                  </tr>
                  <tr>
                    <td>ADT</td>
                    <td>{{ ADULT_BASE_FARE }}</td>
                    <td>{{ ADULT_FEE_N_TAXES }}</td>
                    <td>{{ ADULT_BASE_FARE + ADULT_FEE_N_TAXES }}</td>
                  </tr>

                  <tr>
                    <td>CHD</td>
                    <td>{{ CHILD_BASE_FARE }}</td>
                    <td>{{ CHILD_FEE_N_TAXES }}</td>
                    <td>{{ CHILD_BASE_FARE + CHILD_FEE_N_TAXES }}</td>
                  </tr>
                  <tr>
                    <td>INF</td>
                    <td>{{ INFANT_BASE_FARE }}</td>
                    <td>{{ INFANT_FEE_N_TAXES }}</td>
                    <td>{{ INFANT_BASE_FARE + INFANT_FEE_N_TAXES }}</td>
                  </tr>
                  <tr style="font-weight: bold;">
                    <td>Total</td>
                    <td>{{ TOTAL_BASE_FARE }}</td>
                    <td>{{ TOTAL_FEE_N_TAXES }}</td>
                    <td>{{ TOTAL_AMOUNT }}</td>
                  </tr>
                </table>
              </div>
            </div>

          </div>
          <div class="clr"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="PnrUpdate" role="dialog">
    <div class="modal-dialog modal-sm">
      <div class="modal-content" style="margin: 0 auto;width: 566px;">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">
            &times;
          </button>
          <h4 class="modal-title" *ngIf="IsOnlySid == false ">Update PNR</h4>
          <h4 class="modal-title" *ngIf="IsOnlySid == true ">Update Supplier ID</h4>
        </div>
        <div class="modal-body">
          <div class="inner-pnr">
            <div class="clr"></div>
            <div class="addDiv"></div>
            <table aria-describedby="orderSupplierData" *ngIf="SID == '' && isEmtRequired"
              style="width: 100%;margin-bottom: 10px;">
              <tr>
                <th scope="col" style="padding-right: 91px;">
                  Supplier ID
                </th>
                <ng-container *ngFor="let item of supplierIdList; let i = index">
                  <td style="padding-right: 31px;">
                    <input type="text" style="width: 100%;text-transform: uppercase;" (blur)="getSupplierId(i)"
                      [disabled]='segment_details[i].SUPPLIER_ID != null || (isReturnSupplierSame && i == 1) ? true : false'
                      [(ngModel)]="supplierIdList[i].SUPPLIER_ID" class="form-control m-input"
                      placeholder="Enter Supplier ID " />
                  </td>
                </ng-container>
              </tr>
              <tr *ngIf="siderr != ''">
                <td></td>
                <ng-container *ngFor="let item of supplierIdList; let i = index">
                  <td>
                    <span style="color: red;" id="siderr{{ i }}"> {{ siderr }}</span>
                  </td>
                </ng-container>
              </tr>
            </table>

            <ng-container *ngIf="IsOnlySid == false ">
              <table aria-describedby="orderEmailData" *ngIf="Email_ID == ''" style="width: 100%;margin-bottom: 10px;">
                <tr>
                  <th scope="col">
                    Enter Email
                  </th>
                  <td>
                    <input type="text" style="width: 100%;" [(ngModel)]="Email_ID" class="form-control m-input"
                      placeholder="Enter Email " />
                  </td>
                </tr>
                <tr *ngIf="emailerr != ''">
                  <td></td>
                  <td>
                    <span id="email_Id" style="color: red;"> {{ emailerr }}</span>
                  </td>
                </tr>
              </table>

              <table aria-describedby="orderPNRData" style="width: 100%;margin-bottom: 10px;">
                <tr>
                  <th scope="col" style="padding-right: 14px;">AIRLINE_PNR</th>
                  <ng-container *ngFor="let item of AirlinePnrArray; let i = index">
                    <td style="padding-right: 31px;">
                      <input type="text" style="width: 100%;text-transform: uppercase;" maxlength="6"
                        class="form-control m-input" id="airlinePnr{{ i }}" placeholder="Enter AirLine PNR" />
                    </td>
                  </ng-container>
                </tr>
                <tr>
                  <td></td>
                  <ng-container *ngFor="let item of AirlinePnrArray; let i = index">
                    <td>
                      <span style="color: red;" id="airlinePnrErr{{ i }}"></span>
                    </td>
                  </ng-container>
                </tr>
              </table>

              <table aria-describedby="orderTicketData">
                <tr>
                  <th scope="col" style="width: 8%;">Sr No</th>
                  <th scope="col" style="width: 15%;">Segment</th>
                  <th scope="col" style="width: 19%;">Passenger Name</th>
                  <th scope="col" style="width: 15%;">TICKET_NUMBER</th>
                </tr>
                <tr *ngFor="let item of paxSegDataDetails; let i = index">
                  <td>{{ i + 1 }}</td>

                  <td *ngIf="segment_details.length != 0">
                    {{ segment_details[item.SEGMENT_REF_NO - 1].ORIGIN }} -
                    {{ segment_details[item.SEGMENT_REF_NO - 1].DESTINATION }}
                  </td>
                  <td *ngIf="pax_detail.length != 0">
                    {{ pax_detail[item.PASSENGER_NO - 1].TITLE }}
                    {{ pax_detail[item.PASSENGER_NO - 1].FIRST_NAME }}
                  </td>
                  <td>
                    <input type="text" style="width: 100%;" maxlength="18" class="form-control m-input"
                      id="ticketNo{{ i }}" placeholder="Enter Ticket Number" /><span style="color: red;"
                      id="ticketNoErr{{ i }}"></span>
                  </td>
                </tr>
              </table>
            </ng-container>
            <div class="clr"></div>
            <div class="addDiv"></div>
          </div>

        </div>
        <div class="modal-footer">

          <button type="button" (click)="updatePnr()" class="btn btn-default">
            Update
          </button>
          <button type="button" id="closePnr" (click)="closePnr()" class="btn btn-default" data-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="cancl" role="dialog">
    <div class="modal-dialog modal-sm">
      <div class="modal-content" style="margin: 0 auto;width: 566px;">
        <div class="modal-header">
          <button type="button" id='can' class="close" data-dismiss="modal">
            &times;
          </button>
        </div>
        <div class="modal-body">
          <div>
            <ul class="nav nav-tabs">
              <ng-container *ngFor="let segments of segment_details;let i = index">
                <li [ngClass]='{"active":i==0}'><a data-toggle="tab"
                    [href]="'#segment'+i">{{segments['ORIGIN']}}-{{segments['DESTINATION']}}</a></li>
              </ng-container>
            </ul>
          </div>
          <div class="tab-content">
            <div id="segment0" class="tab-pane fade in active">
              <table aria-describedby="orderPaxAction" class='table '>
                <thead>
                  <tr>
                    <th scope="col">
                      Sr.no
                    </th>
                    <th scope="col">
                      Passengers
                    </th>
                    <th scope="col">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let pax of pax_detail;let i = index">
                    <td>
                      {{i+1}}
                    </td>
                    <td>
                      <h3><label>{{pax['FIRST_NAME']}}{{" "}}{{pax['LAST_NAME']}}</label></h3>
                    </td>
                    <td>
                      <input class="check" (change)="gettingCheckValue($event,'segment0')" type="checkbox" id="{{i}}">
                    </td>
                  </tr>

                </tbody>

              </table>

            </div>
            <div id="segment1" class="tab-pane ">
              <table aria-describedby="orderSeg1PaxData" class='table'>
                <thead>
                  <tr>
                    <th scope="col">
                      Sr.no
                    </th>
                    <th scope="col">
                      Passengers
                    </th>
                    <th scope="col">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let pax of pax_detail;let i = index">
                    <td>
                      {{i+1}}
                    </td>
                    <td>
                      <h3><label>{{pax['FIRST_NAME']}}{{" "}}{{pax['LAST_NAME']}}</label></h3>
                    </td>
                    <td>
                      <input *ngIf="segment_details.length > 1" class="check"
                        (change)="gettingCheckValue($event,'segment1')" type="checkbox" id="{{i}}">
                    </td>
                  </tr>

                </tbody>

              </table>

            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div>
            <button id="cnt" class="btn btn-primary" data-dismiss='modal' style="margin-right: 218px" [disabled]='true'
              (click)=cancelStatus()>
              Cancel Booking
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="reverseMiles" role="dialog">
    <div class="modal-dialog modal-sm">
      <div class="modal-content" style="margin: 0 auto;width: 566px;">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">
            &times;
          </button>
          <h4 class="modal-title">Do you really want to proceed</h4>
        </div>
        <div class="modal-body">
          <div class="inner-pnr">
            <span>Reverse and Refund </span>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" (click)="Reversal()" class="btn btn-default" data-dismiss="modal">
            Proceed
          </button>
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="updateAncillaries" role="dialog" style="overflow-y: auto">
    <div class="modal-dialog">
      <div class="modal-content" style="margin: 48px -144px;width: 90rem;">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">
            &times;
          </button>
          <h4 class="modal-title">{{update_refund_flag?'Update':'Refund'}} Ancillaries</h4>
        </div>
        <div class="modal-body">
          <div class="inner-pnr">
            <div *ngIf="segment_details.length != 0">
              <ul class="nav nav-tabs">

                <ng-container class="col-sm-6" *ngFor="let leg of objectkeys(leg_tabs);let i=index">
                  <li [class]="'col-sm-6'+((leg_tabs[leg].tabactive)?' active':'')">
                    <a data-toggle="tab" [href]="'#'+leg_tabs[leg].ORIGIN+leg_tabs[leg].DESTINATION"
                      (click)="legSelection(leg_tabs[leg].SEGMENT_REF_NO, leg_tabs[leg].LEG_NO)">{{ leg_tabs[leg].ORIGIN
                      }}
                      -
                      {{ leg_tabs[leg].DESTINATION }}</a>
                  </li>
                </ng-container>

              </ul>
              <div class="tab-content">
                <div *ngFor="let leg of objectkeys(leg_tabs);let i=index"
                  [id]="leg_tabs[leg].ORIGIN+leg_tabs[leg].DESTINATION"
                  [class]="'tab-pane fade'+((leg_tabs[leg].tabactive)?' in active':'')">

                  <br>
                  <strong>Select Passenger: </strong> &nbsp;&nbsp;
                  <select [(ngModel)]="defaultOne" (change)="onPaxChangeDyn(defaultOne)"
                    style="background-color: #fff;width:40rem;">
                    <option *ngFor="let item of pax_detail" [ngValue]="item.PASSENGER_NO">
                      {{ item.TITLE }} {{ item.FIRST_NAME }}
                      {{ item.LAST_NAME }}
                    </option>
                  </select>
                  <button class="btn btn-primary btn-sm anc-btn" (click)="leg_tabs[leg].editable=true;showDisabledMsg()"
                    type="submit" style="margin-left: 3rem;margin-top: 0rem;"
                    [ngClass]="{'disableMeWhenCancelled' : booking_details[0].STATUS_NAME === 'Cancelled'}"
                    [disabled]=" RAC_EDIT==1 && leg_tabs[leg].showEdit==false && update_refund_flag == true || (booking_details[0].STATUS_NAME === 'Cancelled')">
                    Edit
                  </button>

                  <div>
                    <div class="d-flex" style="margin-top: 2rem;margin-bottom: 2rem;">

                      <fieldset [disabled]="!leg_tabs[leg].editable">
                        <fieldset>
                          <legend style="display: none;">Seat Ancillaries</legend>
                          <div class="form-group">
                            <label class="col-form-label">Seat</label>
                            <div class="row mt-2">
                              <div class="col-sm-2">
                                <p class="text-center">Status</p>
                                <input type="text" class="form-control text-uppercase"
                                  [value]="bkg_status_map[screen_ancill_data[3].bkgStatus]" readonly />
                              </div>
                              <div class="col-sm-4">
                                <p class="text-center">Description</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="screen_ancill_data[3].description" placeholder="Enter Seat Number"
                                  readonly />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Amount</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="screen_ancill_data[3].amount" placeholder="Amount" readonly />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Miles</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="screen_ancill_data[3].miles" placeholder="Miles" readonly />
                              </div>
                              <button class="btn btn-primary btn-sm anc-btn" (click)="
                          updateAncillariesDataDB('3', screen_ancill_data[3].segment, screen_ancill_data[3].leg)"
                                type="submit" [disabled]="!(screen_ancill_data[3].bkgStatus==0 
                        || screen_ancill_data[3].bkgStatus==1)">
                                {{update_refund_flag?'Confirm':'Fail'}}
                              </button>
                            </div>
                          </div>
                        </fieldset>

                        <fieldset>
                          <legend style="display: none;">Meal Ancillaries</legend>
                          <div class="form-group">
                            <label class="col-form-label">Meal</label>
                            <div class="row mt-2">
                              <div class="col-sm-2">
                                <p class="text-center">Status</p>
                                <input type="text" class="form-control text-uppercase"
                                  [value]="bkg_status_map[screen_ancill_data[1].bkgStatus]" readonly />
                              </div>
                              <div class="col-sm-4">
                                <p class="text-center">Description</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="screen_ancill_data[1].description" placeholder="Enter Meal Type"
                                  [disabled]="isAncilariesEnabled" readonly />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Amount</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="screen_ancill_data[1].amount" placeholder="Amount"
                                  [disabled]="isAncilariesEnabled" readonly />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Miles</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="screen_ancill_data[1].miles" placeholder="Miles"
                                  [disabled]="isAncilariesEnabled" readonly />
                              </div>
                              <button class="btn btn-primary btn-sm anc-btn" (click)="
                    updateAncillariesDataDB('1', screen_ancill_data[1].segment, screen_ancill_data[1].leg)
                    " type="submit" [disabled]="!(screen_ancill_data[1].bkgStatus==0 
                    || screen_ancill_data[1].bkgStatus==1)">
                                {{update_refund_flag?'Confirm':'Fail'}}
                              </button>
                            </div>
                          </div>
                        </fieldset>

                        <fieldset>
                          <legend style="display: none;">Baggage Ancillaries</legend>
                          <div class="form-group">
                            <label class="col-form-label">Baggage</label>
                            <div class="row mt-2">
                              <div class="col-sm-2">
                                <p class="text-center">Status</p>
                                <input type="text" class="form-control text-uppercase"
                                  [value]="bkg_status_map[screen_ancill_data[2].bkgStatus]" readonly />
                              </div>
                              <div class="col-sm-4">
                                <p class="text-center">Description</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="screen_ancill_data[2].description" placeholder="Enter Baggage"
                                  readonly />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Amount</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="screen_ancill_data[2].amount" placeholder="Amount" readonly />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Miles</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="screen_ancill_data[2].miles" placeholder="Miles" readonly />
                              </div>
                              <button class="btn btn-primary btn-sm anc-btn" (click)="
                    updateAncillariesDataDB('2', screen_ancill_data[2].segment, screen_ancill_data[2].leg)"
                                type="submit" [disabled]="!(screen_ancill_data[2].bkgStatus==0 
                  || screen_ancill_data[2].bkgStatus==1)">
                                {{update_refund_flag?'Confirm':'Fail'}}
                              </button>
                            </div>
                          </div>
                        </fieldset>

                        <fieldset>
                          <legend style="display: none;">Lounge Ancillaries</legend>
                          <div class="form-group">
                            <label class="col-form-label">Lounge</label>
                            <div class="row mt-2">
                              <div class="col-sm-2">
                                <p class="text-center">Status</p>
                                <input type="text" class="form-control text-uppercase"
                                  [value]="bkg_status_map[screen_ancill_data[4].bkgStatus]" readonly />
                              </div>
                              <div class="col-sm-4">
                                <p class="text-center">Description</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="screen_ancill_data[4].description" placeholder="Enter Lounge" readonly />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Amount</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="screen_ancill_data[4].amount" placeholder="Amount" readonly />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Miles</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="screen_ancill_data[4].miles" placeholder="Miles" readonly />
                              </div>
                              <button class="btn btn-primary btn-sm anc-btn"
                                (click)="updateAncillariesDataDB('4', screen_ancill_data[4].segment, screen_ancill_data[4].leg)"
                                type="submit" [disabled]="!(screen_ancill_data[4].bkgStatus==0 
                  || screen_ancill_data[4].bkgStatus==1)">
                                {{update_refund_flag?'Confirm':'Fail'}}
                              </button>
                            </div>
                          </div>
                        </fieldset>

                        <fieldset>
                          <legend style="display: none;">Travel Insurance</legend>
                          <div class="form-group">
                            <label class="col-form-label">Travel Insurance</label>
                            <div class="row mt-2">
                              <div class="col-sm-2">
                                <p class="text-center">Status</p>
                                <input type="text" class="form-control text-uppercase"
                                  [value]="bkg_status_map[screen_ancill_data[0].bkgStatus]" readonly />
                              </div>
                              <div class="col-sm-4">
                                <p class="text-center">Policy Number</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="screen_ancill_data[0].description" placeholder="Enter Policy Number"
                                  [disabled]="!(screen_ancill_data[0].bkgStatus==0 
                    || screen_ancill_data[0].bkgStatus==1)" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Amount</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="screen_ancill_data[0].amount" placeholder="Amount" [disabled]="!(screen_ancill_data[0].bkgStatus==0 
                    || screen_ancill_data[0].bkgStatus==1)" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Miles</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="screen_ancill_data[0].miles" placeholder="Miles" [disabled]="!(screen_ancill_data[0].bkgStatus==0 
                    || screen_ancill_data[0].bkgStatus==1)" />
                              </div>
                              <button class="btn btn-primary btn-sm anc-btn" (click)="
                    updateAncillariesDataDB('0', screen_ancill_data[0].segment, screen_ancill_data[0].leg)"
                                type="submit" [disabled]="!(screen_ancill_data[0].bkgStatus==0 
                    || screen_ancill_data[0].bkgStatus==1)">
                                {{update_refund_flag?'Confirm':'Fail'}}
                              </button>
                            </div>
                          </div>
                        </fieldset>

                      </fieldset>
                    </div>
                  </div>
                </div>
                <div id="homeNew" class="tab-pane fade">
                  <div class="d-flex" style="margin-top: 2rem;margin-bottom: 2rem;">
                    <button class="btn btn-primary btn-sm anc-btn" (click)="disableUpdateIn()" type="submit"
                      style="margin-left: 3rem;margin-top: 0rem;">
                      Edit
                    </button>
                  </div>

                  <div>
                    <fieldset [disabled]="updateAncilariesIn">
                      <legend style="display: none;">Update Ancillaries</legend>
                      <div>
                        <fieldset [disabled]="
                            ANCILARIES_STATUS.SSR_TYPE == 33 &&
                            ANCILARIES_STATUS.BOOKING_STATUS == 0
                          ">
                          <legend style="display: none;">Update Ancillaries</legend>
                          <div class="form-group">
                            <label class="col-form-label">Seat</label>
                            <div class="row mt-2">
                              <div class="col-sm-2">
                                <p class="text-center">Status</p>
                                <input type="text" class="form-control text-uppercase"
                                  [value]="bkg_status_map[seatInbound.bkgStatus]" readonly />
                              </div>
                              <div class="col-sm-4">
                                <p class="text-center">Description</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="seatInbound.description" placeholder="Enter Seat Number" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Amount</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="seatInbound.amount"
                                  placeholder="Amount" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Miles</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="seatInbound.miles"
                                  placeholder="Miles" />
                              </div>
                              <button class="btn btn-primary btn-sm anc-btn" (click)="
                                  updateAncillariesInbound('seat', 'Inbound')
                                " type="submit" [disabled]="seatInbound.bkgStatus==undefined">
                                {{update_refund_flag?'Confirm':'Fail'}}
                              </button>
                            </div>
                          </div>
                        </fieldset>

                        <fieldset [disabled]="
                            ANCILARIES_STATUS.SSR_TYPE == 1 &&
                            ANCILARIES_STATUS.BOOKING_STATUS == 0
                          ">
                          <legend style="display: none;">Update Meal Ancillaries</legend>
                          <div class="form-group">
                            <label class="col-form-label">Meal</label>
                            <div class="row mt-2">
                              <div class="col-sm-2">
                                <p class="text-center">Status</p>
                                <input type="text" class="form-control text-uppercase"
                                  [value]="bkg_status_map[mealInbound.bkgStatus]" readonly />
                              </div>
                              <div class="col-sm-4">
                                <p class="text-center">Description</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="mealInbound.description" placeholder="Enter Meal Type"
                                  [disabled]="isAncilariesEnabled" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Amount</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="mealInbound.amount"
                                  placeholder="Amount" [disabled]="isAncilariesEnabled" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Miles</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="mealInbound.miles"
                                  placeholder="Miles" [disabled]="isAncilariesEnabled" />
                              </div>
                              <button class="btn btn-primary btn-sm anc-btn" (click)="
                                  updateAncillariesInbound('meal', 'Inbound')
                                " type="submit" [disabled]="mealInbound.bkgStatus==undefined">
                                Confirm
                              </button>
                            </div>
                          </div>
                        </fieldset>

                        <fieldset [disabled]="
                            ANCILARIES_STATUS.SSR_TYPE == 2 &&
                            ANCILARIES_STATUS.BOOKING_STATUS == 0
                          ">
                          <legend style="display: none;">Update Baggage Ancillaries</legend>
                          <div class="form-group">
                            <label class="col-form-label">Baggage</label>
                            <div class="row mt-2">
                              <div class="col-sm-2">
                                <p class="text-center">Status</p>
                                <input type="text" class="form-control text-uppercase"
                                  [value]="bkg_status_map[baggageInbound.bkgStatus]" readonly />
                              </div>
                              <div class="col-sm-4">
                                <p class="text-center">Description</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="baggageInbound.description" placeholder="Enter Baggage" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Amount</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="baggageInbound.amount" placeholder="Amount" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Miles</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="baggageInbound.miles" placeholder="Miles" />
                              </div>
                              <button class="btn btn-primary btn-sm anc-btn" (click)="
                                  updateAncillariesInbound('baggage', 'Inbound')
                                " type="submit" [disabled]="baggageInbound.bkgStatus==undefined">
                                Confirm
                              </button>
                            </div>
                          </div>
                        </fieldset>

                        <fieldset [disabled]="ANCILARIES_STATUS == '0'">
                          <legend style="display: none;">Update Travel Insurance</legend>
                          <div class="form-group">
                            <label class="col-form-label">Travel Insurance</label>
                            <div class="row mt-2">
                              <div class="col-sm-2">
                                <p class="text-center">Status</p>
                                <input type="text" class="form-control text-uppercase"
                                  [value]="bkg_status_map[tiInbound.bkgStatus]" readonly />
                              </div>
                              <div class="col-sm-4">
                                <p class="text-center">Policy Number</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="tiInbound.description" placeholder="Enter Policy Number" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Amount</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="tiInbound.amount"
                                  placeholder="Amount" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Miles</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="tiInbound.miles"
                                  placeholder="Miles" />
                              </div>
                              -{{tiInbound.bkgStatus}}-
                              -{{tiInbound.description}}-
                              -{{tiInbound.bkgStatus}}-
                              <button class="btn btn-primary btn-sm anc-btn" (click)="
                                  updateAncillariesInbound('travel', 'Inbound')
                                " type="submit" [disabled]="tiInbound.bkgStatus==undefined">
                                Confirm
                              </button>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                    </fieldset>
                  </div>
                </div>

                <div id="menuNew" class="tab-pane fade" *ngIf="segment_details.length > 1">
                  <div class="d-flex" style="margin-top: 2rem;margin-bottom: 2rem;">
                    <strong>Select Passenger : </strong> &nbsp;&nbsp;
                    <select [(ngModel)]="defaultTwo" (change)="onPaxChange(defaultTwo)"
                      style="background-color: #fff;width:40rem;">
                      <option *ngFor="let item of pax_detail" [ngValue]="item.PASSENGER_NO">
                        {{ item.TITLE }} {{ item.FIRST_NAME }}
                        {{ item.LAST_NAME }}</option>
                    </select>
                    <button class="btn btn-primary btn-sm anc-btn" (click)="disableUpdateOut()" type="submit"
                      style="margin-left: 3rem;margin-top: 0rem;">
                      Edit
                    </button>
                  </div>
                  <div *ngIf="showAncilariesDiv == true">
                    <fieldset [disabled]="updateAncilariesOut">
                      <div>
                        <fieldset [disabled]="
                            ANCILARIES_STATUS.SSR_TYPE == 3 &&
                            ANCILARIES_STATUS.BOOKING_STATUS == 0
                          ">
                          <legend style="display: none;">Update Seat Ancillaries</legend>
                          <div class="form-group">
                            <label class="col-form-label">Seat</label>
                            <div class="row mt-2">
                              <div class="col-sm-2">
                                <p class="text-center">Status</p>
                                <input type="text" class="form-control text-uppercase"
                                  [value]="bkg_status_map[seatOutbound.bkgStatus]" readonly />
                              </div>
                              <div class="col-sm-4">
                                <p class="text-center">Description</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="seatOutbound.description" placeholder="Enter Seat Number" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Amount</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="seatOutbound.amount"
                                  placeholder="Amount" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Miles</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="seatOutbound.miles"
                                  placeholder="Miles" />
                              </div>
                              <button class="btn btn-primary btn-sm anc-btn" (click)="
                                  updateAncillariesOutbound('seat', 'Outbound')
                                " type="submit" [disabled]="seatInbound.bkgStatus==undefined">
                                Confirm
                              </button>
                            </div>
                          </div>
                        </fieldset>

                        <fieldset [disabled]="
                            ANCILARIES_STATUS.SSR_TYPE == 1 &&
                            ANCILARIES_STATUS.BOOKING_STATUS == 0
                          ">
                          <legend style="display: none;">Update Meal Ancillaries</legend>
                          <div class="form-group">
                            <label class="col-form-label">Meal</label>
                            <div class="row mt-2">
                              <div class="col-sm-2">
                                <p class="text-center">Status</p>
                                <input type="text" class="form-control text-uppercase"
                                  [value]="bkg_status_map[mealOutbound.bkgStatus]" readonly />
                              </div>
                              <div class="col-sm-4">
                                <p class="text-center">Description</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="mealOutbound.description" placeholder="Enter Meal Type" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Amount</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="mealOutbound.amount"
                                  placeholder="Amount" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Miles</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="mealOutbound.miles"
                                  placeholder="Miles" />
                              </div>
                              <button class="btn btn-primary btn-sm anc-btn" (click)="
                                  updateAncillariesOutbound('meal', 'Outbound')
                                " type="submit" [disabled]="mealInbound.bkgStatus==undefined">
                                Confirm
                              </button>
                            </div>
                          </div>
                        </fieldset>

                        <fieldset [disabled]="
                            ANCILARIES_STATUS.SSR_TYPE == 2 &&
                            ANCILARIES_STATUS.BOOKING_STATUS == 0
                          ">
                          <legend style="display: none;">Update Baggage Ancillaries</legend>
                          <div class="form-group">
                            <label class="col-form-label">Baggage</label>
                            <div class="row mt-2">
                              <div class="col-sm-2">
                                <p class="text-center">Status</p>
                                <input type="text" class="form-control text-uppercase"
                                  [value]="bkg_status_map[baggageOutbound.bkgStatus]" readonly />
                              </div>
                              <div class="col-sm-4">
                                <p class="text-center">Description</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="baggageOutbound.description" placeholder="Enter Baggage" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Amount</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="baggageOutbound.amount" placeholder="Amount" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Miles</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="baggageOutbound.miles" placeholder="Miles" />
                              </div>
                              <button class="btn btn-primary btn-sm anc-btn" (click)="
                                  updateAncillariesOutbound(
                                    'baggage',
                                    'Outbound'
                                  )
                                " type="submit" [disabled]="baggageInbound.bkgStatus==undefined">
                                Confirm
                              </button>
                            </div>
                          </div>
                        </fieldset>

                        <div class="form-group">
                          <label class="col-form-label">Travel Insurance</label>
                          <div class="row mt-2">
                            <div class="col-sm-2">
                              <p class="text-center">Status</p>
                              <input type="text" class="form-control text-uppercase"
                                [value]="bkg_status_map[tiOutbound.bkgStatus]" readonly />
                            </div>
                            <div class="col-sm-4">
                              <p class="text-center">Policy Number</p>
                              <input type="text" class="form-control text-uppercase"
                                [(ngModel)]="tiOutbound.description" placeholder="Enter Policy Number" />
                            </div>
                            <div class="col-sm-2">
                              <p class="text-center">Amount</p>
                              <input type="text" class="form-control text-uppercase" [(ngModel)]="tiOutbound.amount"
                                placeholder="Amount" />
                            </div>
                            <div class="col-sm-2">
                              <p class="text-center">Miles</p>
                              <input type="text" class="form-control text-uppercase" [(ngModel)]="tiOutbound.miles"
                                placeholder="Miles" />
                            </div>
                            <button class="btn btn-primary btn-sm anc-btn" (click)="
                                updateAncillariesOutbound('travel', 'Outbound')
                              " type="submit" [disabled]="tiInbound.bkgStatus==undefined">
                              Confirm
                            </button>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeAncillaries" (click)="closeAncillaries()" class="btn btn-default"
            data-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="growTree" role="dialog" style="overflow-y: auto">
    <div class="modal-dialog">
      <div class="modal-content" style="margin: 48px -144px;width: 90rem;">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">
            &times;
          </button>
          <h4 class="modal-title">Add-ons</h4>
        </div>
        <div class="modal-body">
          <div>
            <span style="font-weight: bold;margin-bottom: 8px;">Grow-Trees</span>
            <div>
              <div class="form-group">
                <div class="row mt-2">
                  <div class="col-sm-3">
                    <p class="text-center">Status</p>
                    <input type="text" class="form-control text-uppercase"
                      [value]="growTreeStatusName" readonly />
                  </div>
                  <div class="col-sm-3">
                    <p class="text-center">Certificate No</p>
                    <input type="text" class="form-control text-uppercase" [value]="growTreeCertificateNo"
                       placeholder="Enter Certificate No" readonly />
                  </div>
                  <div class="col-sm-2">
                    <p class="text-center">Amount</p>
                    <input type="text" class="form-control text-uppercase" [value]="growTreeAmount"
                      placeholder="Enter Amount" readonly />
                  </div>
                  <div class="col-sm-2">
                    <p class="text-center">Miles</p>
                    <input type="text" class="form-control text-uppercase" [value]="growTreeMiles"
                      placeholder="Enter Miles" readonly />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeAncillaries" (click)="closeAncillaries()" class="btn btn-default"
            data-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="updateAncillariesold" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content" style="margin: 0 -144px;width: 90rem;">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">
            &times;
          </button>
          <h4 class="modal-title">Update Ancillaries</h4>
        </div>
        <div class="modal-body">
          <div class="inner-pnr">
            <div *ngIf="segment_details.length != 0">
              <ul class="nav nav-tabs">
                <li class="active col-sm-6">
                  <a data-toggle="tab" href="#homeNew" (click)="segmentSelection(1)">{{ segment_details[0].ORIGIN }} -
                    {{ segment_details[0].DESTINATION }}</a>
                </li>
                <li class="col-sm-6" *ngIf="segment_details.length > 1">
                  <a data-toggle="tab" href="#menuNew" (click)="segmentSelection(2)">{{ segment_details[1].ORIGIN }} -
                    {{ segment_details[1].DESTINATION }}</a>
                </li>
                <li class="col-sm-6" *ngFor="let leg of objectkeys(leg_tabs);let i=index">
                  <a data-toggle="tab" [href]="'#'+leg_tabs[leg].ORIGIN+leg_tabs[leg].DESTINATION"
                    (click)="legSelection(leg.SEGMENT_REF_NO, i)">{{ leg_tabs[leg].ORIGIN }} -
                    {{ leg_tabs[leg].DESTINATION }}</a>
                </li>
              </ul>
              <br>
              <strong>Select Passenger : </strong> &nbsp;&nbsp;
              <select [(ngModel)]="defaultOne" (change)="onPaxChange(defaultOne)"
                style="background-color: #fff;width:40rem;">
                <option *ngFor="let item of pax_detail" [ngValue]="item.PASSENGER_NO">
                  {{ item.TITLE }} {{ item.FIRST_NAME }}
                  {{ item.LAST_NAME }}
                </option>
              </select>
              <div class="tab-content">
                <div *ngFor="let leg of objectkeys(leg_tabs);let i=index"
                  [id]="leg_tabs[leg].ORIGIN+leg_tabs[leg].DESTINATION"
                  [class]="'tab-pane fade'+((leg_tabs[leg].tabactive)?' in active':'')">
                  <div>
                    <div class="d-flex" style="margin-top: 2rem;margin-bottom: 2rem;">
                      {{'tab-pane fade'+((leg_tabs[leg].tabactive)?' in active':'')}}=
                      {{leg_tabs[leg].ORIGIN}}---{{leg_tabs[leg].DESTINATION}}
                    </div>
                  </div>
                </div>
                <div id="homeNew" class="tab-pane fade">
                  <div class="d-flex" style="margin-top: 2rem;margin-bottom: 2rem;">
                    <strong>Select Passenger : </strong> &nbsp;&nbsp;
                    <select [(ngModel)]="defaultOne" (change)="onPaxChange(defaultOne)"
                      style="background-color: #fff;width:40rem;">
                      <option *ngFor="let item of pax_detail" [ngValue]="item.PASSENGER_NO">
                        {{ item.TITLE }} {{ item.FIRST_NAME }}
                        {{ item.LAST_NAME }}
                      </option>
                    </select>

                    <button class="btn btn-primary btn-sm anc-btn" (click)="disableUpdateIn()" type="submit"
                      style="margin-left: 3rem;margin-top: 0rem;">
                      Edit
                    </button>
                  </div>

                  <div>
                    <fieldset [disabled]="updateAncilariesIn">
                      <div>
                        <fieldset [disabled]="
                            ANCILARIES_STATUS.SSR_TYPE == 33 &&
                            ANCILARIES_STATUS.BOOKING_STATUS == 0
                          ">
                          <legend style="display: none;">Update Seat Ancillaries</legend>
                          <div class="form-group">
                            <label class="col-form-label">Seat</label>
                            <div class="row mt-2">
                              <div class="col-sm-2">
                                <p class="text-center">Status</p>
                                <input type="text" class="form-control text-uppercase"
                                  [value]="bkg_status_map[seatInbound.bkgStatus]" readonly />
                              </div>
                              <div class="col-sm-4">
                                <p class="text-center">Description</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="seatInbound.description" placeholder="Enter Seat Number" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Amount</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="seatInbound.amount"
                                  placeholder="Amount" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Miles</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="seatInbound.miles"
                                  placeholder="Miles" />
                              </div>
                              <button class="btn btn-primary btn-sm anc-btn" (click)="
                                  updateAncillariesInbound('seat', 'Inbound')
                                " type="submit" [disabled]="seatInbound.bkgStatus==undefined">
                                Confirm
                              </button>
                            </div>
                          </div>
                        </fieldset>

                        <fieldset [disabled]="
                            ANCILARIES_STATUS.SSR_TYPE == 1 &&
                            ANCILARIES_STATUS.BOOKING_STATUS == 0
                          ">
                          <legend style="display: none;">Update Meal Ancillaries</legend>
                          <div class="form-group">
                            <label class="col-form-label">Meal</label>
                            <div class="row mt-2">
                              <div class="col-sm-2">
                                <p class="text-center">Status</p>
                                <input type="text" class="form-control text-uppercase"
                                  [value]="bkg_status_map[mealInbound.bkgStatus]" readonly />
                              </div>
                              <div class="col-sm-4">
                                <p class="text-center">Description</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="mealInbound.description" placeholder="Enter Meal Type"
                                  [disabled]="isAncilariesEnabled" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Amount</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="mealInbound.amount"
                                  placeholder="Amount" [disabled]="isAncilariesEnabled" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Miles</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="mealInbound.miles"
                                  placeholder="Miles" [disabled]="isAncilariesEnabled" />
                              </div>
                              <button class="btn btn-primary btn-sm anc-btn" (click)="
                                  updateAncillariesInbound('meal', 'Inbound')
                                " type="submit" [disabled]="mealInbound.bkgStatus==undefined">
                                Confirm
                              </button>
                            </div>
                          </div>
                        </fieldset>

                        <fieldset [disabled]="
                            ANCILARIES_STATUS.SSR_TYPE == 2 &&
                            ANCILARIES_STATUS.BOOKING_STATUS == 0
                          ">
                          <legend style="display: none;">Update Baggage Ancillaries</legend>
                          <div class="form-group">
                            <label class="col-form-label">Baggage</label>
                            <div class="row mt-2">
                              <div class="col-sm-2">
                                <p class="text-center">Status</p>
                                <input type="text" class="form-control text-uppercase"
                                  [value]="bkg_status_map[baggageInbound.bkgStatus]" readonly />
                              </div>
                              <div class="col-sm-4">
                                <p class="text-center">Description</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="baggageInbound.description" placeholder="Enter Baggage" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Amount</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="baggageInbound.amount" placeholder="Amount" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Miles</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="baggageInbound.miles" placeholder="Miles" />
                              </div>
                              <button class="btn btn-primary btn-sm anc-btn" (click)="
                                  updateAncillariesInbound('baggage', 'Inbound')
                                " type="submit" [disabled]="baggageInbound.bkgStatus==undefined">
                                Confirm
                              </button>
                            </div>
                          </div>
                        </fieldset>

                        <fieldset [disabled]="ANCILARIES_STATUS == '0'">
                          <legend style="display: none;">Update Travel Insurance</legend>
                          <div class="form-group">
                            <label class="col-form-label">Travel Insurance</label>
                            <div class="row mt-2">
                              <div class="col-sm-2">
                                <p class="text-center">Status</p>
                                <input type="text" class="form-control text-uppercase"
                                  [value]="bkg_status_map[tiInbound.bkgStatus]" readonly />
                              </div>
                              <div class="col-sm-4">
                                <p class="text-center">Policy Number</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="tiInbound.description" placeholder="Enter Policy Number" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Amount</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="tiInbound.amount"
                                  placeholder="Amount" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Miles</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="tiInbound.miles"
                                  placeholder="Miles" />
                              </div>
                              -{{tiInbound.bkgStatus}}-
                              -{{tiInbound.description}}-
                              -{{tiInbound.bkgStatus}}-
                              <button class="btn btn-primary btn-sm anc-btn" (click)="
                                  updateAncillariesInbound('travel', 'Inbound')
                                " type="submit" [disabled]="tiInbound.bkgStatus==undefined">
                                Confirm
                              </button>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                    </fieldset>
                  </div>
                </div>

                <div id="menuNew" class="tab-pane fade" *ngIf="segment_details.length > 1">
                  <div class="d-flex" style="margin-top: 2rem;margin-bottom: 2rem;">
                    <strong>Select Passenger : </strong> &nbsp;&nbsp;
                    <select [(ngModel)]="defaultTwo" (change)="onPaxChange(defaultTwo)"
                      style="background-color: #fff;width:40rem;">
                      <option *ngFor="let item of pax_detail" [ngValue]="item.PASSENGER_NO">
                        {{ item.TITLE }} {{ item.FIRST_NAME }}
                        {{ item.LAST_NAME }}</option>
                    </select>
                    <button class="btn btn-primary btn-sm anc-btn" (click)="disableUpdateOut()" type="submit"
                      style="margin-left: 3rem;margin-top: 0rem;">
                      Edit
                    </button>

                  </div>
                  <div *ngIf="showAncilariesDiv == true">
                    <fieldset [disabled]="updateAncilariesOut">
                      <div>
                        <fieldset [disabled]="
                            ANCILARIES_STATUS.SSR_TYPE == 3 &&
                            ANCILARIES_STATUS.BOOKING_STATUS == 0
                          ">
                          <legend style="display: none;">Update Seat Ancillaries</legend>
                          <div class="form-group">
                            <label class="col-form-label">Seat</label>
                            <div class="row mt-2">
                              <div class="col-sm-2">
                                <p class="text-center">Status</p>
                                <input type="text" class="form-control text-uppercase"
                                  [value]="bkg_status_map[seatOutbound.bkgStatus]" readonly />
                              </div>
                              <div class="col-sm-4">
                                <p class="text-center">Description</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="seatOutbound.description" placeholder="Enter Seat Number" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Amount</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="seatOutbound.amount"
                                  placeholder="Amount" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Miles</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="seatOutbound.miles"
                                  placeholder="Miles" />
                              </div>
                              <button class="btn btn-primary btn-sm anc-btn" (click)="
                                  updateAncillariesOutbound('seat', 'Outbound')
                                " type="submit" [disabled]="seatInbound.bkgStatus==undefined">
                                Confirm
                              </button>
                            </div>
                          </div>
                        </fieldset>

                        <fieldset [disabled]="
                            ANCILARIES_STATUS.SSR_TYPE == 1 &&
                            ANCILARIES_STATUS.BOOKING_STATUS == 0
                          ">
                          <legend style="display: none;">Update Meal Ancillaries</legend>
                          <div class="form-group">
                            <label class="col-form-label">Meal</label>
                            <div class="row mt-2">
                              <div class="col-sm-2">
                                <p class="text-center">Status</p>
                                <input type="text" class="form-control text-uppercase"
                                  [value]="bkg_status_map[mealOutbound.bkgStatus]" readonly />
                              </div>
                              <div class="col-sm-4">
                                <p class="text-center">Description</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="mealOutbound.description" placeholder="Enter Meal Type" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Amount</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="mealOutbound.amount"
                                  placeholder="Amount" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Miles</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="mealOutbound.miles"
                                  placeholder="Miles" />
                              </div>
                              <button class="btn btn-primary btn-sm anc-btn" (click)="
                                  updateAncillariesOutbound('meal', 'Outbound')
                                " type="submit" [disabled]="mealInbound.bkgStatus==undefined">
                                Confirm
                              </button>
                            </div>
                          </div>
                        </fieldset>

                        <fieldset [disabled]="
                            ANCILARIES_STATUS.SSR_TYPE == 2 &&
                            ANCILARIES_STATUS.BOOKING_STATUS == 0
                          ">
                          <legend style="display: none;">Update Baggage Ancillaries</legend>
                          <div class="form-group">
                            <label class="col-form-label">Baggage</label>
                            <div class="row mt-2">
                              <div class="col-sm-2">
                                <p class="text-center">Status</p>
                                <input type="text" class="form-control text-uppercase"
                                  [value]="bkg_status_map[baggageOutbound.bkgStatus]" readonly />
                              </div>
                              <div class="col-sm-4">
                                <p class="text-center">Description</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="baggageOutbound.description" placeholder="Enter Baggage" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Amount</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="baggageOutbound.amount" placeholder="Amount" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Miles</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="baggageOutbound.miles" placeholder="Miles" />
                              </div>
                              <button class="btn btn-primary btn-sm anc-btn" (click)="
                                  updateAncillariesOutbound(
                                    'baggage',
                                    'Outbound'
                                  )
                                " type="submit" [disabled]="baggageInbound.bkgStatus==undefined">
                                Confirm
                              </button>
                            </div>
                          </div>
                        </fieldset>

                        <div class="form-group">
                          <label class="col-form-label">Travel Insurance</label>
                          <div class="row mt-2">
                            <div class="col-sm-2">
                              <p class="text-center">Status</p>
                              <input type="text" class="form-control text-uppercase"
                                [value]="bkg_status_map[tiOutbound.bkgStatus]" readonly />
                            </div>
                            <div class="col-sm-4">
                              <p class="text-center">Policy Number</p>
                              <input type="text" class="form-control text-uppercase"
                                [(ngModel)]="tiOutbound.description" placeholder="Enter Policy Number" />
                            </div>
                            <div class="col-sm-2">
                              <p class="text-center">Amount</p>
                              <input type="text" class="form-control text-uppercase" [(ngModel)]="tiOutbound.amount"
                                placeholder="Amount" />
                            </div>
                            <div class="col-sm-2">
                              <p class="text-center">Miles</p>
                              <input type="text" class="form-control text-uppercase" [(ngModel)]="tiOutbound.miles"
                                placeholder="Miles" />
                            </div>
                            <button class="btn btn-primary btn-sm anc-btn" (click)="
                                updateAncillariesOutbound('travel', 'Outbound')
                              " type="submit" [disabled]="tiInbound.bkgStatus==undefined">
                              Confirm
                            </button>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeAncillaries" (click)="closeAncillaries()" class="btn btn-default"
            data-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="refundAncillaries" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content" style="margin: 0 auto;width: 70rem;">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">
            &times;
          </button>
          <h4 class="modal-title">Refund Ancillaries</h4>
        </div>
        <div class="modal-body">
          <div class="inner-pnr">
            <div class="" *ngIf="segment_details.length != 0">
              <ul class="nav nav-tabs">
                <li class="active col-sm-6">
                  <a data-toggle="tab" href="#refundHome" (click)="segmentSelection(1)">{{ segment_details[0].ORIGIN }}
                    -
                    {{ segment_details[0].DESTINATION }}</a>
                </li>
                <li class="col-sm-6" *ngIf="segment_details.length > 1">
                  <a data-toggle="tab" href="#refundMenu" (click)="segmentSelection(2)">{{ segment_details[1].ORIGIN }}
                    -
                    {{ segment_details[1].DESTINATION }}</a>
                </li>
              </ul>

              <div class="tab-content">
                <div id="refundHome" class="tab-pane fade in active">
                  <div class="d-flex" style="margin-top: 2rem;margin-bottom: 2rem;">
                    <strong>Select Passenger : </strong> &nbsp;&nbsp;
                    <select [(ngModel)]="defaultOne" (change)="onPaxChange(defaultOne)"
                      style="background-color: #fff;width:40rem;">
                      <option *ngFor="let item of pax_detail" [ngValue]="item.PASSENGER_NO">
                        {{ item.TITLE }} {{ item.FIRST_NAME }}
                        {{ item.LAST_NAME }}</option>
                    </select>
                    <button class="btn btn-primary btn-sm anc-btn" (click)="disableRefundIn()" type="submit"
                      style="margin-left: 3rem;margin-top: 0rem;">
                      Edit
                    </button>

                  </div>

                  <div *ngIf="showAncilariesDiv == true">
                    <fieldset [disabled]="refundAncilariesIn">
                      <div>
                        <fieldset [disabled]="
                            ANCILARIES_STATUS.SSR_TYPE == 33 &&
                            ANCILARIES_STATUS.BOOKING_STATUS == 0
                          ">
                          <legend style="display: none;">Update Seat Ancillaries</legend>
                          <div class="form-group">
                            <label class="col-form-label">Seat</label>
                            <div class="row mt-2">
                              <div class="col-sm-2">
                                <p class="text-center">Status</p>
                                <input type="text" class="form-control text-uppercase"
                                  [value]="bkg_status_map[seatInbound.bkgStatus]" readonly />
                              </div>
                              <div class="col-sm-4">
                                <p class="text-center">Description</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="seatInbound.description" placeholder="Enter Seat Number" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Amount</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="seatInbound.amount"
                                  placeholder="Amount" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Miles</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="seatInbound.miles"
                                  placeholder="Miles" />
                              </div>
                              <button class="btn btn-primary btn-sm anc-btn" (click)="
                                  refundAncillariesInbound('seat', 'Inbound')
                                " type="submit" [disabled]="seatInbound.bkgStatus==undefined">
                                Fail
                              </button>
                            </div>
                          </div>
                        </fieldset>

                        <fieldset [disabled]="
                            ANCILARIES_STATUS.SSR_TYPE == 1 &&
                            ANCILARIES_STATUS.BOOKING_STATUS == 0
                          ">
                          <legend style="display: none;">Update Meal Ancillaries</legend>
                          <div class="form-group">
                            <label class="col-form-label">Meal</label>
                            <div class="row mt-2">
                              <div class="col-sm-2">
                                <p class="text-center">Status</p>
                                <input type="text" class="form-control text-uppercase"
                                  [value]="bkg_status_map[mealInbound.bkgStatus]" readonly />
                              </div>
                              <div class="col-sm-4">
                                <p class="text-center">Description</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="mealInbound.description" placeholder="Enter Meal Type" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Amount</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="mealInbound.amount"
                                  placeholder="Amount" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Miles</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="mealInbound.miles"
                                  placeholder="Miles" />
                              </div>
                              <button class="btn btn-primary btn-sm anc-btn" (click)="
                                  refundAncillariesInbound('meal', 'Inbound')
                                " type="submit" [disabled]="mealInbound.bkgStatus==undefined">
                                Fail
                              </button>
                            </div>
                          </div>
                        </fieldset>

                        <fieldset [disabled]="
                            ANCILARIES_STATUS.SSR_TYPE == 2 &&
                            ANCILARIES_STATUS.BOOKING_STATUS == 0
                          ">
                          <legend style="display: none;">Update Baggage Ancillaries</legend>
                          <div class="form-group">
                            <label class="col-form-label">Baggage</label>
                            <div class="row">
                              <div class="col-sm-2">
                                <p class="text-center">Status</p>
                                <input type="text" class="form-control text-uppercase"
                                  [value]="bkg_status_map[baggageInbound.bkgStatus]" readonly />
                              </div>
                              <div class="col-sm-4">
                                <p class="text-center">Description</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="baggageInbound.description" placeholder="Enter Baggage" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Amount</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="baggageInbound.amount" placeholder="Amount" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Miles</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="baggageInbound.miles" placeholder="Miles" />
                              </div>
                              <button class="btn btn-primary btn-sm anc-btn" (click)="
                                  refundAncillariesInbound('baggage', 'Inbound')
                                " type="submit" [disabled]="baggageInbound.bkgStatus==undefined">
                                Fail
                              </button>
                            </div>
                          </div>
                        </fieldset>

                        <fieldset [disabled]="
                          ANCILARIES_STATUS.SSR_TYPE == 0 &&
                          ANCILARIES_STATUS.BOOKING_STATUS == 0">
                          <legend style="display: none;">Update Travel Insurance</legend>
                          <div class="form-group">
                            <label class="col-form-label">Travel Insurance</label>
                            <div class="row mt-2">
                              <div class="col-sm-2">
                                <p class="text-center">Status</p>
                                <input type="text" class="form-control text-uppercase"
                                  [value]="bkg_status_map[tiInbound.bkgStatus]" readonly />
                              </div>
                              <div class="col-sm-4">
                                <p class="text-center">Policy Number</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="tiInbound.description" placeholder="Enter Policy Number" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Amount</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="tiInbound.amount"
                                  placeholder="Amount" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Miles</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="tiInbound.miles"
                                  placeholder="Miles" />
                              </div>
                              <button class="btn btn-primary btn-sm anc-btn" (click)="
                                  refundAncillariesInbound('travel', 'Inbound')
                                " type="submit" [disabled]="tiInbound.bkgStatus==undefined">
                                Fail
                              </button>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                    </fieldset>
                  </div>
                </div>
                <div id="refundMenu" class="tab-pane fade" *ngIf="segment_details.length > 1">
                  <div class="d-flex" style="margin-top: 2rem;margin-bottom: 2rem;">
                    <strong>Select Passenger : </strong> &nbsp;&nbsp;
                    <select [(ngModel)]="defaultTwo" (change)="onPaxChange(defaultTwo)"
                      style="background-color: #fff;width:40rem;">
                      <option *ngFor="let item of pax_detail" [ngValue]="item.PASSENGER_NO">
                        {{ item.TITLE }}
                        {{ item.FIRST_NAME }}
                        {{ item.LAST_NAME }}</option>
                    </select>
                    <button class="btn btn-primary btn-sm anc-btn" (click)="disableRefundOut()" type="submit"
                      style="margin-left: 3rem;margin-top: 0rem;">
                      Edit
                    </button>

                  </div>
                  <div *ngIf="showAncilariesDiv == true">
                    <fieldset [disabled]="refundAncilariesOut">
                      <div>
                        <fieldset [disabled]="
                            ANCILARIES_STATUS.SSR_TYPE == 3 &&
                            ANCILARIES_STATUS.BOOKING_STATUS == 0
                          ">
                          <legend style="display: none;">Update Seat Ancillaries</legend>
                          <div class="form-group">
                            <label class="col-form-label">Seat</label>
                            <div class="row mt-2">
                              <div class="col-sm-2">
                                <p class="text-center">Status</p>
                                <input type="text" class="form-control text-uppercase"
                                  [value]="bkg_status_map[seatOutbound.bkgStatus]" readonly />
                              </div>
                              <div class="col-sm-4">
                                <p class="text-center">Description</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="seatOutbound.description" placeholder="Enter Seat Number" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Amount</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="seatOutbound.amount"
                                  placeholder="Amount" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Miles</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="seatOutbound.miles"
                                  placeholder="Miles" />
                              </div>
                              <button class="btn btn-primary btn-sm anc-btn" (click)="
                                  refundAncillariesOutbound('seat', 'Outbound')
                                " type="submit" [disabled]="seatInbound.bkgStatus==undefined">
                                Fail
                              </button>
                            </div>
                          </div>
                        </fieldset>

                        <fieldset [disabled]="
                            ANCILARIES_STATUS.SSR_TYPE == 1 &&
                            ANCILARIES_STATUS.BOOKING_STATUS == 0
                          ">
                          <legend style="display: none;">Update Meal Ancillaries</legend>
                          <div class="form-group">
                            <label class="col-form-label">Meal</label>
                            <div class="row mt-2">
                              <div class="col-sm-2">
                                <p class="text-center">Status</p>
                                <input type="text" class="form-control text-uppercase"
                                  [value]="bkg_status_map[mealOutbound.bkgStatus]" readonly />
                              </div>
                              <div class="col-sm-4">
                                <p class="text-center">Description</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="mealOutbound.description" placeholder="Enter Meal Type" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Amount</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="mealOutbound.amount"
                                  placeholder="Amount" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Miles</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="mealOutbound.miles"
                                  placeholder="Miles" />
                              </div>
                              <button class="btn btn-primary btn-sm anc-btn" (click)="
                                  refundAncillariesOutbound('meal', 'Outbound')
                                " type="submit" [disabled]="mealInbound.bkgStatus==undefined">
                                Fail
                              </button>
                            </div>
                          </div>
                        </fieldset>

                        <fieldset [disabled]="
                            ANCILARIES_STATUS.SSR_TYPE == 2 &&
                            ANCILARIES_STATUS.BOOKING_STATUS == 0
                          ">
                          <legend style="display: none;">Update Baggage Ancillaries</legend>
                          <div class="form-group">
                            <label class="col-form-label">Baggage</label>
                            <div class="row mt-2">
                              <div class="col-sm-2">
                                <p class="text-center">Status</p>
                                <input type="text" class="form-control text-uppercase"
                                  [value]="bkg_status_map[baggageOutbound.bkgStatus]" readonly />
                              </div>
                              <div class="col-sm-4">
                                <p class="text-center">Description</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="baggageOutbound.description" placeholder="Enter Baggage" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Amount</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="baggageOutbound.amount" placeholder="Amount" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Miles</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="baggageOutbound.miles" placeholder="Miles" />
                              </div>
                              <button class="btn btn-primary btn-sm anc-btn" (click)="
                                  refundAncillariesOutbound(
                                    'baggage',
                                    'Outbound'
                                  )
                                " type="submit" [disabled]="baggageInbound.bkgStatus==undefined">
                                Fail
                              </button>
                            </div>
                          </div>
                        </fieldset>

                        <fieldset [disabled]="
                          ANCILARIES_STATUS.SSR_TYPE == 0 &&
                          ANCILARIES_STATUS.BOOKING_STATUS == 0">
                          <legend style="display: none;">Update Travel Insurance</legend>
                          <div class="form-group">
                            <label class="col-form-label">Travel Insurance</label>
                            <div class="row mt-2">
                              <div class="col-sm-2">
                                <p class="text-center">Status</p>
                                <input type="text" class="form-control text-uppercase"
                                  [value]="bkg_status_map[tiOutbound.bkgStatus]" readonly />
                              </div>
                              <div class="col-sm-4">
                                <p class="text-center">Policy Number</p>
                                <input type="text" class="form-control text-uppercase"
                                  [(ngModel)]="tiOutbound.description" placeholder="Enter Policy Number" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Amount</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="tiOutbound.amount"
                                  placeholder="Amount" />
                              </div>
                              <div class="col-sm-2">
                                <p class="text-center">Miles</p>
                                <input type="text" class="form-control text-uppercase" [(ngModel)]="tiOutbound.miles"
                                  placeholder="Miles" />
                              </div>
                              <button class="btn btn-primary btn-sm anc-btn" (click)="
                                  refundAncillariesOutbound(
                                    'travel',
                                    'Outbound'
                                  )
                                " type="submit" [disabled]="tiInbound.bkgStatus==undefined">
                                Fail
                              </button>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeAncillaries" (click)="closeAncillaries()" class="btn btn-default"
            data-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>

  <button class="btn-pnr" data-toggle="modal" data-target="#updateAncilariesMessage" style="visibility: hidden"
    id="updateAncilariesMessageBtn">
    Refund Ancillaries
  </button>
  <div class="modal fade" id="updateAncilariesMessage" role="dialog" data-backdrop="false">
    <div class="modal-dialog modal-sm" style="margin-top: 50px;">
      <div class="modal-content" style="margin: 0 auto;width: 450px;">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">
            &times;
          </button>
          <h4 class="modal-title" id="ancillary_update_header">Update Status</h4>
        </div>
        <div class="modal-body">
          <div class="inner-pnr">
            <span>Data Updated Successfully </span>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>

  <button class="btn-pnr" data-toggle="modal" data-target="#updateAncilariesError" style="visibility: hidden"
    id="updateAncilariesErrorBtn">
    Refund Ancillaries
  </button>
  <div class="modal fade" id="updateAncilariesError" role="dialog" data-backdrop="false">
    <div class="modal-dialog modal-sm" style="margin-top: 50px;">
      <div class="modal-content" style="margin: 0 auto;width: 450px;">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">
            &times;
          </button>
          <h4 class="modal-title" id="ancillary_update_header">Update Status</h4>
        </div>
        <div class="modal-body">
          <div class="inner-pnr">
            <span>Please enter valid data </span>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>

  <button class="btn-pnr" data-toggle="modal" data-target="#updateCustomMsg" style="visibility: hidden"
    id="updateCustomMsgBtn">
    Refund Ancillaries
  </button>
  <div class="modal fade" id="updateCustomMsg" role="dialog" data-backdrop="false">
    <div class="modal-dialog modal-sm" style="margin-top: 50px;">
      <div class="modal-content" style="margin: 0 auto;width: 450px;">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">
            &times;
          </button>
          <h4 class="modal-title" id="ancillary_update_header">{{custom_header}}</h4>
        </div>
        <div class="modal-body">
          <div class="inner-pnr">
            <span>{{custom_msg}} </span>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>

  <button class="btn-pnr" data-toggle="modal" data-target="#updateConfirmMsg" style="visibility: hidden"
    id="updateConfirmMsgBtn">
    Confirm mail
  </button>
  <div class="modal fade" id="updateConfirmMsg" role="dialog" data-backdrop="false">
    <div class="modal-dialog modal-sm" style="margin-top: 50px;">
      <div class="modal-content" style="margin: 0 auto;width: 520px;">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">
            &times;
          </button>
          <h4 class="modal-title" id="ancillary_update_header">{{custom_header}}</h4>
        </div>
        <div class="modal-body">
          <div class="inner-pnr">
            <span>{{custom_msg}} </span>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal" (click)="sendConfirmMail()">
            Yes
          </button>
          <button type="button" class="btn btn-default" data-dismiss="modal">
            No
          </button>
        </div>
      </div>
    </div>
  </div>

</ng-container>

<ng-container *ngIf="loader == true">
  <div>
    <div style="margin: 0 auto; text-align: center;">
      <img src="../../../../assets/img/Loading_Animation.gif" width="8%" height="8%" alt="Loader" />
    </div>
  </div>
</ng-container>